import queryString from 'query-string';

export const profileTypes = {
  USER: 'user',
  ORGANISATION: 'organisation',
  PUBLISHER: 'publisher',
  TRANSLATION_PARTNER: 'translation-partner'
};

export const publisherTabs = {
  lists: 'lists'
};

export const emergentReaderLevel = {
  emergentReader: '1-ER',
  emergentReaderText: '1 (Emergent Readers)'
};

export const mapProfileTypeToSlug = {
  [profileTypes.ORGANISATION]: 'organisations',
  [profileTypes.PUBLISHER]: 'publishers',
  [profileTypes.TRANSLATION_PARTNER]: 'translation-partners',
  [profileTypes.USER]: 'users'
};

export const collectionLimits = {
  small: 6,
  medium: 20
};

export const starRatingQuestions = [
  {
    name: "not-great",
    questions: ["tools", "language-tools", "publishing", "tips"],
  },
  {
    name: "okay",
    questions: ["tools", "language-tools", "publishing", "tips"],
  },
  {
    name: "satisfied",
    questions: ["tools", "language-tools", "publishing", "tips"],
  },
  {
    name: "good",
    questions: ["tools", "language-tools", "publishing", "tips"],
  },
  {
    name: "excellent",
    questions: ["tools", "language-tools", "publishing", "tips"],
  }];

export const imageSrcsetSizes = {
  grid2up6up: {
    '(min-width: 1048px)': {
      value: 200,
      unit: 'px'
    },
    '(min-width: 768px)': 34, // unit vw
    'default': 50 // unit vw
  },
  grid4up: {
    '(min-width: 1048px)': {
      value: 280,
      unit: 'px'
    },
    '(min-width: 768px)': 34, // unit vw
    'default': 50 // unit vw
  },
}

export const keyCodes = {
  leftArrow: 37,
  upArrow: 38,
  rightArrow: 39,
  downArrow: 40,
  esc: 27,
  f: 70,
  return: 13,
};

export const orientation = {
  portrait: 'portrait',
  landscape: 'landscape'
};

export const pagination = {
  allBooks: 24,
  allLists: 24,
  images: 24,
  allIllustrations: 24,
  usersSearch: 20,
  organisationsSearch: 20,
  bookTranslations: 24,
  default: 24,
  homeBooks: 12
};

export const sortOptions = {
  relevance: 'Relevance',
  newArrivals: 'New Arrivals',
  community: 'Community',
  mostRead: 'Most Read',
  mostLiked: 'Most Liked',
  editorsPicks: 'Editor\'s Picks',
  mostViewed: 'Most Viewed',
  ratings: 'Ratings'
};

export const bulkDownloadOptions = {
  allImages: 'All Images',
  allStories: 'All Stories',
  notDownloaded: 'Not Downloaded'
};

export const defaultBulkDownloadFormat = {
  stories: 'PDF',
  images: 'JPEG'
};

export const mailIds = {
  helpMailId: 'help@storyweaver.org.in ',
  swMailId: 'storyweaver@prathambooks.org',
  partnershipMailId: 'partnerships@prathambooks.org',
  contactUs: 'contact@storyweaver.org.in',
};

export const subDomains = {
  ddl: 'ddl',
  gd: 'globaldream'
}

export const studentMenuWhitelist = ["/student", "/stories", "/audios", "/lists/"]

export const userTypes = {
  individualUser: 'individual-user',
  edOrg: 'ed-org',
  edTech: 'ed-tech',
  teacher: 'teacher',
  parent: 'parent',
  student: 'student',
  creator: 'creator'
};

export const masterUserProfileTypes = {
  userType: [
    { value: 'teacher', displayText: 'Teacher' },
    { value: 'parent', displayText: 'Parent' },
    { value: 'student', displayText: 'Student' },
    { value: 'ed-org', displayText: 'Educational Organisation' },
    { value: 'ed-tech', displayText: 'Ed-Tech' },
    { value: 'creator', displayText: 'Creator' },
    { value: 'others', displayText: 'Others' },
  ]
}

export const flpUserProfileTypes = {
  userType: [
    { value: 'teacher', displayText: 'Teacher' },
    { value: 'parent', displayText: 'Parent' },
    { value: 'student', displayText: 'Student' },
    { value: 'others', displayText: 'Others' },
  ]
}

export const otherOptions = [
  { name: 'Select', queryValue: 'Select' },
  { name: 'Curriculum Developer', queryValue: 'Curriculum Developer' },
  { name: 'Government Official', queryValue: 'Government Official' },
  { name: 'Librarian', queryValue: 'Librarian' },
  { name: 'Publisher', queryValue: 'Publisher' },
  { name: 'Storyteller', queryValue: 'Storyteller' },
  { name: 'Other', queryValue: 'Other' }
]

export const flpOtherOptions = [
  { name: 'Select', queryValue: 'Select' },
  { name: 'Curriculum Developer', queryValue: 'Curriculum Developer' },
  { name: 'Government Official', queryValue: 'Government Official' },
  { name: 'Librarian', queryValue: 'Librarian' },
  { name: 'Publisher', queryValue: 'Publisher' },
  { name: 'Storyteller', queryValue: 'Storyteller' },
  { name: 'Ed-Org', queryValue: 'ed-org' },
  { name: 'Ed-Tech', queryValue: 'ed-tech' },
  { name: 'Creator', queryValue: 'creator' },
  { name: 'Other', queryValue: 'Other' }
]

export const nextSuggestionsTypes = {
  nextRead: 'Next Read',
  nextTranslation: 'Next Translation',
  nextListRead: 'Next List Read',
  newStoryFinder: 'New Story Read'
};

export const itemCountTypes = {
  books: 'books_count',
  lists: 'lists_count',
  images: 'illustrations_count',
  people: 'users_count',
  organisations: 'organisation_count',
  stem: 'stem_count'
};


export const selectionStates = {
  selectedOnly: 1,
  selectedAndCommented: 2
};

export const readingLevels = [
  { name: 'Level 1 (Emergent Readers)', queryValue: 'Level 1 (Emergent Readers)' },
  { name: 'Level 1', queryValue: 'Level 1' },
  { name: 'Level 2', queryValue: 'Level 2' },
  { name: 'Level 3', queryValue: 'Level 3' },
  { name: 'Level 4', queryValue: 'Level 4' }
]

export const siteLocale = typeof window !== 'undefined' ? (localStorage.getItem('locale') || 'en') : 'en';

export const links = {
  allBooksPath: () =>   `/${siteLocale}/stories`,
  allBooks: (sortOption = sortOptions.ratings, languagePreferences = [], readingLevels = [], category = [], story_type = []) =>
    `/${siteLocale}/stories?${queryString.stringify({ sort: sortOption, language: languagePreferences, level: readingLevels, category: category, story_type: story_type })}`,
  allAudioBooks: (sortOption = sortOptions.ratings, languagePreferences = [], readingLevels = [], story_type = ['audio']) => `/${siteLocale}/audios?${queryString.stringify({ sort: sortOption, language: languagePreferences, level: readingLevels, story_type: story_type, isAudio: true })}`,
  allTranslate: (appliedFilters, source_language, target_language) => `/${siteLocale}/translate/all?${queryString.stringify({ category: appliedFilters.category, publisher: appliedFilters.publisher, level: appliedFilters.level, source_language: source_language, target_language: target_language })}`,
  analytics: () => `https://dashboard.storyweaver.org.in/`,
  blog: () => `/${siteLocale}/v0/blog`,
  blogPosts: () => `/${siteLocale}/v0/blog_posts`,
  blogDashboard: () => `/${siteLocale}/v0/blog/dashboard`,
  bookDetails: (slug) => `/${siteLocale}/stories/${slug}`,
  ece: (lang) => `/${siteLocale}/early-learning-resources?language=${lang}`,
  eceThemes: (lang, theme) => `/${siteLocale}/early-learning-resources/theme?language=${lang}&identifier=${theme}`,
  eceVideos: (lang) => `/${siteLocale}/early-learning-resources/videos?language=${lang}`,
  ecePosters: (lang) => `/${siteLocale}/early-learning-resources/conversation-posters?language=${lang}`,
  levelDetails: (level, lang) => `/${siteLocale}/foundational-literacy/levels?language=${lang}&level=${level}`,
  csfLevelshareUrl: (level, lang) => `/${siteLocale}/foundational-literacy/levels?language=${lang}%26level=${level}`,
  programOverview: (key, lang) => `/${siteLocale}/foundational-literacy/program-overview?language=${lang}&tab=${key}`,
  routineDetails: (id, lang) => `/${siteLocale}/foundational-literacy/levels?language=${lang}&instructional_routine_id=${id}`,
  resourceDetails: (id, lang) => `/${siteLocale}/foundational-literacy/resource/${id}?language=${lang}`,
  contests: () => `/${siteLocale}/v0/contests`,
  create: () => `/${siteLocale}/v0/editor/create`,
  dashboard: () => `/${siteLocale}/v0/dashboard`,
  editor: (id) => `/${siteLocale}/v0/editor/story/${id}`,
  editPublishedStory: (id) => `/${siteLocale}/v0/stories/${id}/editable`,
  editDraftStory: (rootStoryId, bookId) => `/${siteLocale}/editor/${rootStoryId}/mobile-translate/${bookId}/book-title`,
  editContestDraftStory: (slug, contestSlug) => `/${siteLocale}/v0/editor/story/${slug}?contest_id=${contestSlug}`,
  home: () => `/${siteLocale}`,
  lists: () => `/${siteLocale}/lists`,
  csf: (lang) => `/${siteLocale}/foundational-literacy?language=${lang}`,
  csfLevels: (lang) => `/${siteLocale}/foundational-literacy/levels?language=${lang}`,
  images: () => `/${siteLocale}/v0/illustrations`,
  illustrationV0: (slug) => `/${siteLocale}/v0/illustrations/${slug}`,
  downloadList: (slug) => `/${siteLocale}/v0/lists/${slug}/download?d_format=pdf&high_resolution=false`,
  allIllustrations: (sortOption = sortOptions.relevance) => `/${siteLocale}/illustrations?sort=${sortOption}`,
  illustration: (slug) => `/${siteLocale}/illustrations/${slug}`,
  illustrationRating: (id) => `/${siteLocale}/v0/illustrations/review_illustrations/${id}`,
  login: () => `/${siteLocale}/users/sign_in`,
  myLists: () => `/${siteLocale}/me/lists`,
  offlineBooks: () => `/${siteLocale}/offline`,
  offlineTranslateBooks: () => `/${siteLocale}/offline/translate`,
  profile: (type, slug, tab) => `/${type}/${slug}?${queryString.stringify({ tab: tab })}`,
  profileDashboard: (params) => `/${siteLocale}/v0/profile${params ? '?' + queryString.stringify(params) : ''}`,
  editProfile: () => `/${siteLocale}/profile`,
  privacyPolicy: () => `/${siteLocale}/privacy-policy`,
  publisherAnalytics: () => `/${siteLocale}/v0/dashboard/publisher_analytics`,
  publisherDashboard: () => `/${siteLocale}/v0/dashboard/publisher_private_images`,
  rateStory: () => `/${siteLocale}/v0/reviewer/un_reviewed_stories`,
  rateIllustration: () => `/${siteLocale}/v0/reviewer/un_reviewed_illustrations`,
  ratingDashboard: () => `/${siteLocale}/v0/dashboard/un_reviewed_stories`,
  relevelBook: (slug) => `/${siteLocale}/v0/editor/${slug}/relevel`,
  signup: () => `/${siteLocale}/users/sign_up`,
  reading_levels: () => `/${siteLocale}/reading-levels`,
  translateFaq: () => `/${siteLocale}/faqs#faq3`,
  educatorFaq: () => `/${siteLocale}/faqs#faq5`,
  translate: () => `/${siteLocale}/translate`,
  translateFromSeeAll: (appliedFilters, source_language, target_language) => `/translate?${queryString.stringify({ category: appliedFilters.category, publisher: appliedFilters.publisher, level: appliedFilters.level, source_language: source_language, target_language: target_language })}`,
  translateBook: (slug) => `/${siteLocale}/v0/editor/${slug}/translate`,
  translateBookToLanguage: (slug, toLanguage) => `/${siteLocale}/v0/editor/${slug}/translate?to_language=${toLanguage}`,
  mobileTranslateBook: (parent_story_id, translated_story_id) =>`/${siteLocale}/editor/${parent_story_id}/mobile-translate/${translated_story_id}/book-title`,
  tpTranslateBookToLanguageDesktop: (slug, toLanguage) => `/api/v1/profile/translate_story/${slug}/?to_language=${toLanguage}&translator_story=true&tp_dashboard=true&locale=${siteLocale}`,
  tpTranslateBookToLanguageMobile: (slug, toLanguage) => `/api/v1/profile/translate_story/${slug}/?to_language=${toLanguage}&mobile_translate=true&translator_story=true&tp_dashboard=true&locale=${siteLocale}`,
  translationDashboard: () => `/${siteLocale}/v0/dashboard/translate_stories`,
  translationAnalytics: () => `/${siteLocale}/v0/dashboard/transation_partner_anlaytics`,
  searchBy: (query) => `/${siteLocale}/search?query=${query}`,
  searchByTag: (tag) => `/${siteLocale}/search?tags=${tag}`,
  searchByCategory: (query) => `/${siteLocale}/search?${queryString.stringify({ category: query })}`,
  searchByIllustration: (slug) => `/${siteLocale}/stories?illustration_slug=${slug}`,
  searchIllustrationsByTag: (tag) => `/${siteLocale}/search?tags=${tag}&item=images`,
  searchIllustrationsByCategory: (query) => `/${siteLocale}/search?${queryString.stringify({ category: query, tab: "images" })}`,
  searchIllustrationsByStyle: (query) => `/${siteLocale}/search?${queryString.stringify({ style: query, tab: "images" })}`,

  untranslatedStories: () => `/${siteLocale}/translator/un_translated_stories`,
  jotformDashboard: () => `/${siteLocale}/jotform-dashboard`,
  unreviewedStories: () => `/${siteLocale}/v0/profile/un_edited_stories_new`,
  userProfile: (slug) => `/${siteLocale}/users/${slug}`,
  userProfileBookShelf: (slug) => `/${siteLocale}/users/${slug}?bookShelf`,
  createStoryFromIllustration: (slug) => `/${siteLocale}/v0/stories/create_story_from_illustration?id=${slug}`,
  storiesByCategory: (query) => `/${siteLocale}/stories?${queryString.stringify({ category: query, isStoryCategory: true })}`,
  ccLicense: () => `https://creativecommons.org/licenses/by/4.0/`,
  termsOfUse: () => `/${siteLocale}/terms-and-conditions`,
  uploadGoodPractice:() => `/${siteLocale}/uploading_an_illustration#faq2`,
  bulkStoriesDownload: (query) => `/api/v1/bulk-download?${queryString.stringify(query)}`,
  bulkImagesDownload: (query) => `/api/v1/image-bulk-download?${queryString.stringify(query)}`,
  confirmationLink: () => `/${siteLocale}/users/confirmation/new`,
  offlineBooksFormLink: () => `https://docs.google.com/forms/d/e/1FAIpQLSdkyvnn0j-q3TcLNRP2UrRuRmTIkvHgypu9wqT-SkBl_Hc1JQ/viewform`,
  homePopUpPhoneStoryLink: () => `https://storyweaver.org.in/stories/26690-miss-laya-s-fantastic-motorbike-does-not-like-fruits`,
  swPlatform: () => `https://storyweaver.org.in`,
  list: (slug) => `/${siteLocale}/lists/${slug}`,
  googleFormBookDownloadLink: (userDetails) => `https://docs.google.com/forms/d/e/1FAIpQLScugX7B5Xcc-AwNec6qt3OlW8Kq-RPLESrGqF2ACE-Hjtb-3w/viewform?entry.1402735984=${userDetails.userEmail || ''}&entry.1884270710=${userDetails.name || ''}&entry.749985689=${userDetails.organisation || 'N.A.'}&entry.482710811=${userDetails.country || 'N.A.'}`,
  googleFormIllustrationDownloadLink: (userDetails) => `https://docs.google.com/forms/d/e/1FAIpQLSeVdiSywdbtYXxr92mPZwHMSMgpRzZ26bMIa7-n-C4s7lktjw/viewform?usp=pp_url&entry.1620316252=${userDetails.userEmail || ''}&entry.318407001=${userDetails.name || ''}&entry.368081528=${userDetails.organisation || 'N.A.'}&entry.1199464032=${userDetails.country || 'N.A.'}`,
  storyReview: (slug) => `/${siteLocale}/v0/stories/${slug}/story-review?flag=true`,
  mailToLink: (mailId) => `mailto:${mailId}`,
  allLists: (query) => `/${siteLocale}/lists/?${queryString.stringify(query)}`,
  myDrafts: () => `/${siteLocale}/v0/profile/drafts`,
  userOrgDetails: (org_id) => `/${siteLocale}/v0/profile/user_org_details?org_id=${org_id}`,
  videos: () => `/${siteLocale}/videos`,
  donate: () => `/${siteLocale}/donate`,
  learnAtHome: () => `https://learnathome.storyweaver.org.in/?utm_source=sw-&utm_medium=optimizebanner&utm_campaign=lah-launch`,
  userOpdsDashboard: () => `/${siteLocale}/v0/dashboard/opds_partner_analytics`,
  rp: (lang) => `/${siteLocale}/reading-programme?language=${lang}`,
  campaigns: (name) => `/${siteLocale}/about/campaigns/${name}`,
  enrollRpTutorial: () => 'https://docs.google.com/presentation/d/1zCda8PXmi-rovuYJ61ni0bw1vrvuC6ifxC2Z06CQYJg/edit?usp=sharing',
  rpMissionHandbook: () => 'https://drive.google.com/file/d/1V_swtTHalI8q67frw6ZkiJxkMC4le10n/view',
  rpManual: () => 'https://drive.google.com/file/d/1zb8NpaRW7-wy_dkyOKZSR3EGW_2CBh5G/view',
  flpHome: (lang, ps) => `/${siteLocale}/foundational-literacy-programme?language=${lang}${ps ? '&ps=' + ps : ''}`,
  flpHomeGrades: (lang, grade, ps) => `/${siteLocale}/foundational-literacy-programme/grades?language=${lang}&grade=${grade}${ps ? '&ps=' + ps : ''}`,
  flpHomeAbout: (slug, lang, ps) => `/${siteLocale}/foundational-literacy-programme/${slug}?language=${lang}${ps ? '&ps=' + ps : ''}`,
  flpResourceDetails: (id, lang, ps) => `/${siteLocale}/foundational-literacy-programme/resource/${id}?language=${lang}${ps ? '&ps=' + ps : ''}`,
  parentHome: () => `/${siteLocale}/parent`,
  studentHome: () => `/${siteLocale}/student`,
  educatorHome: () => `/${siteLocale}/educator`,
  stemHome: (lang) => `/${siteLocale}/stem-literacy-programme?language=${lang}`,
  stemSubjects: (subject,lang) => `/${siteLocale}/stem-literacy-programme/${subject}?language=${lang}`,
  stemResources: (lang) => `/${siteLocale}/stem-literacy-programme/trainingresources?language=${lang}`,
  stemResourcesModule: (id, lang) => `/${siteLocale}/stem-literacy-programme/trainingresources/${id}?language=${lang}`,
  stemTopics: (grade=[], subject=[], lang) => `/${siteLocale}/stem-literacy-programme/stem-topics?${queryString.stringify({grade: grade, subject: subject, language: lang})}`,
  stemAbout: (slug, lang) => `/${siteLocale}/stem-literacy-programme/about/${slug}?language=${lang}`,
  stemGrouping: (slug,subject, lang) => `/${siteLocale}/stem-literacy-programme/about/stem-topics/${subject}/${slug}?language=${lang}`,
  STEMTopic: (lang) => `/${siteLocale}/stem-literacy-programme/about/stem-topics?language=${lang}`,
  stemLP: (subject, id, lang) => `/${siteLocale}/stem-literacy-programme/${subject}/lesson-plan/${id}?language=${lang}`,
  stemLPTag: (tag, lang) => `/${siteLocale}/stem-literacy-programme/tags?tag=${tag}&language=${lang}`,
  stemBook: (id, lang='en') => `/${siteLocale}/stem-literacy-programme/stories/${id}?language=${lang}`,
  stemBrochure: () => 'https://drive.google.com/file/d/1ptrCkPkAT5O130oHTJLkwecpz3IKePi8/view?usp=sharing',
  campaignPage: (slug) => `/about/campaigns${slug}`,
  pledgeToRead: (lang, section) => `/${siteLocale}/about/campaigns/getchildrenreading?${queryString.stringify({language: lang, section: section})}`,
  gcrSubCampaign: (lang, org) => `/${siteLocale}/about/campaigns/getchildrenreading/partner?org=${org}&language=${lang}`,
  pledgeToReadPartner: (lang) => `/${siteLocale}/about/campaigns/getchildrenreading/pcertificate?${queryString.stringify({language: lang})}`,
  pledgeToReadOdos: (lang) => `/${siteLocale}/about/campaigns/getchildrenreading/odoscertificate?${queryString.stringify({language: lang})}`,
  pledgeToReadVideo: (lang) => `/${siteLocale}/about/campaigns/getchildrenreading/worldbookday23?language=${lang}`,
  flpClassroom: (lang) => `/${siteLocale}/foundational-create-classroom?language=${lang}`,
  flpMyClassroom: (lang) => `/${siteLocale}/foundational-create-classroom/my-classrooms?language=${lang}`,
  flpClassStudents: (id, lang) => `/${siteLocale}/foundational-create-classroom/my-classrooms/${id}?language=${lang}`,
  flpMoocResources: (lang, ps) => `/${siteLocale}/foundational-literacy-programme/trainingresources?language=${lang}${ps ? '&ps=' + ps : ''}`,
  flpMoocResourcesModule: (slug, lang, ps) => `/${siteLocale}/foundational-literacy-programme/trainingresources/${slug}?language=${lang}${ps ? '&ps=' + ps : ''}`,
  storyDetails: (slug) => `/${siteLocale}/stories/${slug}`,
  embedReader: (slug) => `/${siteLocale}/stories/embed/reader/${slug}`,
  newsPage: (slug) => `/${siteLocale}/latest/in-the-news${slug}`,
  flpAllBooks: (lang, level, ps) => `/${siteLocale}/foundational-literacy-programme/all-books?language=${lang}${level ? `&level=${level}`: ''}${ps ? '&ps=' + ps : ''}`,
  allImpacts: () => `/${siteLocale}/about/impact-stories`,
  impacts: (name) => `/${siteLocale}/about/impact${name}`,
  awardsPage: () => `/${siteLocale}/impact/awards`,
  careers: (slug) =>  `/${siteLocale}/careers/${slug}`,
  eventCertificate: (lang, eventType) => `/${siteLocale}/certificates?event_type=${eventType}&language=${lang}`,
};

export const contact_links = {
  'facebook': 'https://www.facebook.com/pbstoryweaver',
  'twitter': 'https://twitter.com/PBStoryWeaver',
  'instagram': 'https://www.instagram.com/pbstoryweaver/',
  'linkedIn': 'https://www.linkedin.com/company/pratham-books/',
  'youtube': 'http://bit.ly/2q2uNNN'
}

export const ddlLinks = {
  home: () => 'https://darakhtdanesh.org/en',
  library: () => 'https://library.darakhtdanesh.org/en/resources',
  submitResource: () => 'https://library.darakhtdanesh.org/en/add/resourcefile',
  contact: () => 'https://library.darakhtdanesh.org/en/contact-us',
  disclaimer: () => 'https://library.darakhtdanesh.org/en/page/35',
  terms: () => 'https://library.darakhtdanesh.org/en/page/33',
  privacy: () => 'https://library.darakhtdanesh.org/en/page/34',
  links: () => 'https://library.darakhtdanesh.org/en/page/812',
  libraryHelp: () => 'https://library.darakhtdanesh.org/en/page/1275',
  facebook: () => 'https://facebook.com/AfghanOERs',
  twitter: () => 'https://twitter.com/AfghanOERs',
  youtube: () => 'https://www.youtube.com/channel/UCVmc4QsedamLXMeXbutW-iw/videos'
}

export const gdLinks = {
  home: () => 'https://next-pwa-literacy-rajan-halwitscom.vercel.app/',
  contact: () => 'https://globaldream.guru/ContactUs.aspx',
  privacy: () => 'https://dignityeducation.org/privacy_policy.aspx',
  facebook: () => 'https://www.facebook.com/GlobalDream2F2E',
  twitter: () => 'https://twitter.com/GlobalDreamGuru',
  youtube: () => 'https://www.youtube.com/user/GlobalDream2F2E'
}

export const feedbackLinks = {
  ListModal: 'https://docs.google.com/forms/d/e/1FAIpQLSfe1Wn1hnbjEHILZ72b04IeN8JLN7QjQTGX0Am33CbewRdfLQ/viewform?usp=sf_link',
  EnglishSubscriptionModal: 'https://www.youtube.com/channel/UCBY9VtZ0aH6sf6gu5Q3Zwng?view_as=subscriber'
};

export const gcrGoogleFormLinks = {
  'odos': 'https://docs.google.com/forms/d/e/1FAIpQLSd5NqSe9FvWmPQEsaaDvYYBXfdYBZN2ZuuII5vB30vGp1DWyg/viewform'
}

export const headerBackgroundUrls = {
  defaultHeaderBgUrl:
    'https://storage.googleapis.com/story-weaver-e2e-production/illustrations/2136/large/Illustration-7.jpg',
  readalongHeaderBgUrl: {
    source: [
      { width: "max-width: 480px", imgUrl: "https://storage.googleapis.com/story-weaver-e2e-production/background-images/Banner%20readalong%20mobile.png" },
      { width: "min-width: 481px", imgUrl: "https://storage.googleapis.com/story-weaver-e2e-production/background-images/Banner%20Readalong1090x200.jpg" },
    ],
    defaultSrc: "https://storage.googleapis.com/story-weaver-e2e-production/background-images/Banner%20Readalong1090x200.jpg",
    altText: "readalong-banner"
  },
  listsHeaderBgUrl: {
    source: [
      { width: "max-width: 480px", imgUrl: "https://storage.googleapis.com/story-weaver-e2e-production/background-images/Banner%20List%20mobile.png" },
      { width: "min-width: 481px", imgUrl: "https://storage.googleapis.com/story-weaver-e2e-production/background-images/banner%20Image%20Lists.jpg" },
    ],
    defaultSrc: "https://storage.googleapis.com/story-weaver-e2e-production/background-images/banner%20Image%20Lists.jpg",
    altText: "lists-banner"
  },
  certifiedUrl : "https://static.storyweaver.org.in/illustrations/ptr-certified.gif"
};

export const roles = {
  CONTENT_MANAGER: 'content_manager',
  PUBLISHER: 'publisher',
  REVIEWER: 'reviewer',
  ILLUSTRATION_REVIEWER: 'illustration_reviewer',
  STUDIO_TEAM: 'studio_team'
}

export const delays = {
  ListModal: 30000,
  slimNotificationModal: 8000,
  slimNotificationMediumDelay: 12000,
  slimNotificationLongDelay: 16000
}

export const limits = {
  charLimit: 144,
  cardStringLimit: 30
}

export const siteHeaderHight = {
  height: 57
}

export const offlineBooksUrl = ['read', 'reading-programme', 'flp-home', 'stem-home', 'translate']
export const offlineBookUrls = ['/offline/read', '/offline/reading-programme', '/offline/flp-home', '/offline/stem-home', '/offline/translate']


export const programOverviewUrls = ['about', 'how-to-use', 'levelling-framework', 'instructional-routines']

export const userFeedbackPopups = {
  'ReviewerSuggestionPopup': 'ReviewerSuggestionPopup',
  'AuthorSuggestionPopup': 'AuthorSuggestionPopup'
}

export const animationTypes = {
  okay: 'okay',
  like: 'like',
  love: 'love'
}

export const userAuthStages = {
  'empty': 'empty',
  'password': 'password',
  'userInfo': 'userInfo',
  'language': 'language',
  'userPreferences': 'userPreferences',
  'newPassword': 'newPassword',
  'resetPassword': 'resetPassword',
  'onlyMessage': 'onlyMessage',
  'resendConfirmationMail': 'resendConfirmationMail',
  'mandatoryLogin': 'mandatoryLogin',
  'otp': 'otp',
  'social': 'social',
  'mandatoryLoginEmail': 'mandatoryLoginEmail',
};

export const gaEventCategories = {
  'list': 'List',
  'listFilters': 'FilterLists',
  'offline': 'Offline',
  'categoryCard': 'CategoryCard',
  'book': 'Book',
  'banner': 'banner',
  'bookShelf': 'bookshelf',
  'illustration': 'Illustration',
  'booksResources': 'books_resources',
  'bulkDownload': 'bulkDownload',
  'profile': 'Profile',
  'nextReadSuggestion': 'NextReadSuggestion',
  'programmeOverview': 'programme_overview',
  'smileyRating': 'SmileyRating',
  'audioSmileyRating': 'AudioSmileyRating',
  'imageBulkDownload': 'ImageBulkDownload',
  'filterRead': 'FilterRead',
  'filterReadalong': 'FilterReadalong',
  'filterImage': 'FilterImage',
  'filterTranslate': 'FilterTranslate',
  'translation': 'Translation',
  'navigation': 'navigation',
  'localization': 'Localization',
  'userRegistration': 'user_registration',
  'listSideIcons': 'list_side_icons',
  'homePage': 'homepage',
  'translateHome': 'translate_home',
  'homePageParent': 'homepage_parent',
  'homePageTeacher': 'homepage_teacher',
  'homePageStudent': 'homepage_student',
  'readingProgram': 'reading_programme',
  'suggestEdits': 'suggest_edits',
  'offlineTranslation': 'OfflineTranslation',
  'readAtHome': 'read_at_home',
  'mobileTranslate': 'mobile_translate',
  'YTVideo': 'YT_video',
  'donate': 'Donate',
  'csf': 'CSF',
  'edit_profile': 'edit_profile',
  'staticPages': 'Static Pages',
  'gosticha': 'Goshticha Shaniwar',
  'gatingForm': 'Gating Form',
  'editProfile': 'edit_profile',
  'searchAutoSuggestion': 'Search Auto-Suggestion',
  'ece': 'ECE',
  'eceLevelFilter': 'ECE Level Filter',
  'themeFilter': 'Theme Filter',
  'cbse': 'CBSE Reading Mission',
  'flpHome': 'FLP_at_home',
  'rpSurvey': 'RP_survey',
  'mainMenu': 'main_menu',
  'imagesHome': 'images_home',
  'imageDetails': 'image_details',
  'stem': 'STEM',
  'stemAbout': "STEM_about_page",
  'lessonPlan': 'lesson_plan',
  'stemLp': 'STEM_lesson_plan',
  'stemAllStem': 'STEM_all_topic',
  'stemAllStemSubject': 'STEM_all_subject_topic',
  'stemTopicsPage': 'STEM_topics_page',
  'stemTagPage': 'STEM_tags_page',
  'allStem': 'all_topic',
  'allStemSubject': 'all_subject_topic',
  'stemCampaign': 'STEM_campaign',
  'newDonate': 'donate',
  'flpOneToMany': 'FLP_one_to_many',
  'stemMooc' : 'STEM_mooc',
  'storyDetailsPage': 'story_details_page',
  'flpMooc' : 'FLP_mooc',
  'campaignPledge': 'campaign_pledge_gcr',
  'misc': 'miscellaneous',
  'contact': 'contact_us',
  'popupModal': 'popup_modal',
  'flpMerge': 'FLP_merge',
  'pressNews': 'press_news',
  'wordless': 'Wordless',
  'readalongs': 'Readalongs',
  'bilinguals': 'Bilinguals'
};

export const gaEventActions = {
  'download': 'Download',
  'read': 'Read',
  'add': 'Add',
  'delete': 'Delete',
  'liked': 'Liked',
  'opened': 'Opened',
  'closed': 'Closed',
  'clicked': 'clicked',
  'clickedViewBooks': 'clicked_view_books',
  'clickedImage': 'clicked_image',
  'clickedUpload': 'clicked_upload',
  'clickedReport': 'clicked_report',
  'clickedRegisterModal': 'clicked_register_modal',
  'clickedBaselineStart': 'clicked_baseline_start',
  'clickedEndlineStart': 'clicked_endline_start',
  'clickedBaselineSubmit': 'clicked_baseline_submit',
  'closedBaselineTest': 'closed_baseline_test',
  'startedWorkSheet': 'started_worksheet',
  'shared': 'Shared',
  'bookPageOpenedFromList': 'BookDetailsPageOpenedFromList',
  'listened': 'Listened',
  'carousel': 'carousel',
  'clicked_lesson_plan': 'clicked_lesson_plan',
  'language_grade_subject': 'language_grade_subject',
  'listenCompleted': 'listen_completed',
  'skipped': 'Skipped',
  'flagged': 'Flagged',
  'back': 'Back',
  'submit': 'Submit',
  'listenAbandoned': 'Listen Abandoned',
  'nextTranslate': 'NextTranslate',
  'languageNotification': 'languageNotif',
  'viewAll': 'ViewAll',
  'home': 'home',
  'readalong': 'readalong',
  'lists': 'lists',
  'search': 'search',
  'images': 'images',
  'create': 'create',
  'translate': 'translate',
  'offline_library': 'offline_library',
  'readCompleted': 'read_completed',
  'downloadPopUpOpened': 'Download PopUp Opened',
  'bookDownloadPopUpFormOpened': 'Download PopUp Form Link Opened',
  'languageChange': 'Language Change',
  'prompted': 'prompted',
  'login': 'login',
  'signup': 'signup',
  'assigned': 'assigned',
  'sideListSaveOffline': 'save_offline',
  'sideListMoreInfo': 'more_info',
  'featuredStories': 'featured_stories',
  'mostRead': 'most_read',
  'newArrivals': 'new_arrivals',
  'awardWinning': 'award_winning',
  'readingProgramme': 'reading_programme',
  'programPlayVideo': 'program_play_video',
  'moduleSelect': 'module_select',
  'moduleEnroll': 'module_enroll',
  'themeLanguageSelect': 'theme_language_select',
  'themeSelect': 'theme_select',
  'themeEnroll': 'theme_enroll',
  'themeRemoveFromDashboard': 'theme_remove_from_dashboard',
  'themeShare': ['theme_share_to_whatsapp', 'theme_share_to_twitter', 'theme_share_to_facebook'],
  'lessonPreview': 'lesson_preview',
  'lessonReadAgain': 'lesson_read_again',
  'lessonContinueReading': 'lesson_continue_reading',
  'lessonCompletedFlag': 'lesson_completed_flag',
  'lessonRating': 'lesson_rating',
  'lessonReview': 'lesson_review',
  'certificateEarned': 'certificate_earned',
  'certificateDownloaded': 'Certificate Download',
  'certificateShared': ['certificate_shared_to_facebook', 'certificate_shared_to_twitter', 'certificate_shared_to_whatsapp'],
  'certificateSharedGeneral':'certificate_shared',
  'programContinueButton': 'program_continue_button',
  'moduleContinueButton': 'module_continue_button',
  'testimonialUpload': 'testimonial_upload',
  'certificatesView': 'certificates_view',
  'certificateSeen':'certificate_seen',
  'resources_view': 'resources_view',
  'menuUsage': 'menu_usage',
  'suggestEditsClicked': 'suggest_edits_clicked',
  'submitSuggestions': 'submit_suggestions',
  'exitSuggestEdits': 'exit_suggest_edits',
  'resolve': 'resolve',
  'blockUserSuggestions': 'block_user_suggestions',
  'blockStorySuggestions': 'block_story_suggestions',
  'viewInTranslator': 'view_in_translator',
  'doneViewingSuggestions': 'done_viewing_suggestions',
  'pickAnotherStory': 'pick_another_story',
  'translateAnyway': 'translate_anyway',
  'sync': 'sync',
  'save': 'save',
  'tipsViewed': 'TipsViewed',
  'coachMarks': 'coach_marks',
  'popup': 'pop_up',
  'startTranslate': 'started_translate',
  'translateAnotherStory': 'translate_another_story',
  'viewOriginalPage': 'view_original_page',
  'nextPage': 'next_page',
  'previousPage': 'previous_page',
  'skipToPage': 'skip_to_page',
  'publish': 'publish',
  'saveAsDraft': 'save_as_draft',
  'start': 'start',
  'preview': 'preview',
  'discard': 'discard',
  'goToTranslate': 'go_to_translate',
  'goToCheck': 'go_to_check',
  'goToPublish': 'go_to_publish',
  'close': 'close',
  'leave': 'leave',
  'cancel': 'cancel',
  'accessVideo': 'access_video',
  'accessVideosPage': 'access_videos_page',
  'emailSignup': 'email_signup',
  'newUserAdded': 'new_user_added',
  'backButton': 'back_button',
  'closeButton': 'close_button',
  'facebook': 'facebook',
  'google': 'google',
  'email': 'email',
  'OTP': 'OTP',
  'donate': 'donate',
  'view': 'view',
  'deleteBookshelf': 'DeleteBookshelf',
  'share': 'Share',
  'allBooks': 'all_books',
  'more': 'more',
  'resources': 'resources',
  'learnAtHome': 'learn_at_home',
  'topDonateButton': 'topDonateButton',
  'bottomDonateButton': 'bottomDonateButton',
  'views': 'views',
  'menuViews': 'menu_views',
  'Facebook': 'Facebook',
  'twitter': 'Twitter',
  'whatsapp': 'Whatsapp',
  'csf': 'CSF',
  'csfBooks': 'All Books',
  'levelEntry': 'Level Entry',
  'attempt': 'attempt',
  'gif': 'GIF',
  'clicks': 'Clicks',
  'editPicture': 'edit_picture',
  'updateUserProfile': 'update_user_profile',
  'orgUser': 'org_user',
  'languagePreference': 'language_preference',
  'levelPreference': 'level_preference',
  'Close': 'Close',
  'ece': 'ECE',
  'posterRead': 'Poster Read',
  'posterDownload': 'Poster Download',
  'posterShare': 'Poster Share',
  'flp': 'FLP_at_home',
  'listen': 'Listen',
  'telegram': 'Telegram',
  'enrolledSelf': 'Enrolled-Self:Enrolled',
  'enrolledNag': 'Enrolled-Nag:Enrolled',
  'enrolSelf': 'Enroll Now-Self:Popup',
  'enrolNag': 'Enroll Now-Nag:Popup',
  'registerSelf': 'Enroll Now-Self:Register',
  'registerNag':'Enroll Now-Nag:Register',
  'registrationComplete': 'clicked_submit',
  'registerPopup':'register_grade_clicked',
  'signupPopup': 'Signup Popup',
  'sectionViewed': 'Section Viewed',
  'cbseEligible': 'clicked_yes',
  'cbseNotEligible':'clicked_no',
  'exitRegistration': 'exit_registration',
  'closeRegistration': 'closed_registration',
  'closedRegisterModal': 'closed_register_modal',
  'keepWriting': 'Keep Writing',
  'writeStory': 'Write Story',
  'rated': 'rated',
  'formSubmit': 'form_submitted',
  'baselineStart': 'baseline_test_starts',
  'baselineComplete': 'baseline_test_completed',
  'startReading': 'started_reading',
  'baselineClosed': 'baseline_test_closed',
  'viewedMilestoneJotform': 'milestone_test_started',
  'startedMileStoneTest': 'started_milestone_test',
  'endedMilestoneJotform': 'milestone_test_ended',
  'submittedMileStoneTest':'submitted_milestone_test',
  'closedMilestoneJotform': 'milestone_test_closed',
  'closedMileStoneTest': 'closed_milestone_test',
  'viewedMilestonePdf': 'milestone_viewed',
  'viewedMileStone':'viewed_milestone',
  'closedMilestonePdf': 'milestone_closed',
  'closedMileStone':'closed_milestone',
  'endlineStart': 'endline_test_starts',
  'startedEndlineTest':'started_endline_test',
  'endlineComplete': 'endline_test_completed',
  'submittedEndlineTest':'submitted_endline_test',
  'endlineClosed': 'endline_test_closed',
  'closedEndlineTest':'closed_endline_test',
  'certificateDownload': 'certificate_downloaded',
  'bookFinderClicked': 'book_finder_clicked',
  'bookFinderSubmitted': 'book_finder_submitted',
  'bookFinderClosed': 'book_finder_closed',
  'bookScrolled': 'story_scrolled',
  'levelSelected': 'level_selected',
  'clickedLanguage': 'clicked_language',
  'clickedSpotlight': 'clicked_spotlight_list',
  'clickedLevel': 'clicked_level',
  'listSelected': 'list_selected',
  'clickedStory': 'clicked_story',
  'bookCompleted': 'story_completed',
  'bookNotCompleted': 'story_not_completed',
  'ratingSubmitted': 'rating_submitted',
  'closedSuggestions': 'closed_the selected_stories',
  'langClicked': 'language_clicked',
  'clickedSearch': 'clicked_search',
  'discover': 'discover',
  'themeSelected': 'theme_selected',
  'resourceSelected': 'resource_selected',
  'listClicked': 'list_clicked',
  'videoClicked': 'video_clicked',
  'submitStoryStart': 'submit_story_started',
  'submitStoryClose': 'submit_story_closed',
  'subjectClicked': 'subject_clicked',
  'storyClicked': 'story_clicked',
  'clickedResourcePt': 'clicked_resource_pt',
  'clickedResource': 'clicked_resource',
  'clickedResourceList': 'clicked_resource_list',
  'clickedForMe': 'clicked_handpicked_for_me',
  'clickedBooks': 'clicked_books',
  'clickedReadalongs': 'clicked_readalongs',
  'clickedRp': 'clicked_rp',
  'clickedReadingList': 'clicked_reading_list',
  'parentSelected': 'parent_selected',
  'studentSelected': 'student_selected',
  'educatorSelected': 'educator_selected',
  'enrollRpEn': 'enroll_now_rp_english',
  'enrollRpHi': 'enroll_now_rp_hindi',
  'cbseDraftCircular': 'cbse_draft_circular',
  'evalRubrics': 'evaluation_rubrics',
  'guidelinesStory': 'guidelines_story',
  'clickedWhatsapp': 'clicked_whatsapp',
  'clickedTwitter': 'clicked_twitter',
  'clickedFacebook': 'clicked_facebook',
  'clickedTelegram': 'clicked_telegram',
  'registerPhase': 'register_phase_2_clicked',
  'clickedNext': 'clicked_next',
  'clickedGrade': 'clicked_grade',
  'selfInitiated': 'self_initiated',
  'nagInitiated': 'nag_initiated',
  'droppedAuth': 'dropped_off_auth',
  'emailClicked': 'email_clicked',
  'otpClicked': 'otp_clicked',
  'googleClicked': 'google_clicked',
  'facebookClicked': 'facebook_clicked',
  'validEmail': 'entered_valid_email',
  'validPhoneNumber': 'entered_valid_phone_number',
  'droppedOffOtp': 'dropped_off_otp',
  'droppedOffEmail': 'dropped_off_email',
  'googleLogin': 'google_login',
  'facebookLogin': 'facebook_login',
  'emailSignUp': 'email_sign_up',
  'emailLogin': 'email_login',
  'otpLogin': 'otp_login',
  'closedStories': 'closed_selected_stories',
  'moduleSelected': 'module_selected',
  'clickedEnroll': 'clicked_enroll',
  'clickedProceed': 'clicked_proceed',
  'startedListening': 'started_listening',
  'clickedViewList': 'clicked_view_list',
  'clickedLoadMore': 'clicked_load_more',
  'allListsHome': 'all_lists_home',
  'clickedQuickView': 'clicked_quick_view',
  'closedQuickView': 'closed_quick_view',
  'registerGrade': 'register_for_grade_clicked',
  'storyGuidelines': 'clicked_story_guidelines',
  'clickedCircular': 'clicked_circular',
  'clickedRubrics': 'clicked_evaluation_rubrics',
  'cbseAboutProgramme': 'clicked_about_programme',
  'clickedRegister': 'clicked_register',
  'clickedBonusResources': 'clicked_bonus_resources',
  'clickedFaq': 'clicked_faq',
  'clickedPhase': 'clicked_phase',
  'clickedBonusGrade': 'clicked_bonus_grade',
  'clickedReg': 'clicked_register_to_start_reading',
  'clickedJoin': 'clicked_join_programme',
  'fileDownload': 'file_download',
  'stem': 'stem_clicked',
  'clickedLike': 'clicked_like',
  'clickedBookshelf': 'clicked_my_bookshelf',
  'clickedTranslateNow': 'clicked_translate_now',
  'clickedTheme': 'clicked_theme',
  'savedStory': 'saved_story',
  'deletedFromLibrary': 'deleted_from_library',
  'bottomButton': 'bottom_button',
  'bookShelf': 'bookshelf',
  'translateInitiated': 'translation_initiated',
  'translateStart': 'translation_started',
  'storyClosed': 'story_modal_closed',
  'enterScreen': 'enter_fullscreen',
  'exitScreen': 'exit_fullscreen',
  'closedSelectedStories': 'closed_the_selected_stories',
  'startDeletion': 'start_deletion',
  'clickedCreator': 'clicked_creator',
  'clickedCreate': 'clicked_create',
  'bookshelfAdded': 'new_bookshelf_added',
  'existingBookshelf': 'existing_bookshelf',
  'closedBookshelf': 'closed_bookshelf',
  'bookDeleted': 'book_deleted',
  'worksheetStarted': 'worksheet_started_no',
  'worksheetClosed': 'worksheet_closed_no',
  'worksheetSubmitted': 'worksheet_submitted_no',
  'clickedLogo': 'clicked_logo',
  'donateTop': 'clicked_donate_top',
  'donateBottom': 'clicked_donate_bottom',
  'donateType': 'clicked_donate_type',
  'clickDonate': 'clicked_donate',
  'clickedPoster': 'clicked_poster',
  'clickedAllPosters': 'clicked_all_posters',
  'clickedVideo': 'clicked_video',
  'clickedSwEmail': 'clicked_sw_email',
  'nagDonate': 'nag_donate',
  'closeDonate': 'closed_donate',
  'submittedWorksheet': 'submitted_worksheet',
  'clickedLetsRead':'clicked_lets_read',
  'clickedTranslateOffline': 'clicked_translate_offline',
  'saveOfflineLibrary': 'saved_to_offline_library',
  'listDetailsPage': 'list_details_page',
  'searchAllPage': 'search_all_page',
  'filterSort': 'filter_sort',
  'storyTile': 'story_tile',
  'removeOfflineLibrary': 'delete_from_offline_library',
  'addStories': 'add_stories',
  'removeStories': 'remove_stories',
  'clickedStart': 'clicked_start',
  'addClass': 'clicked_add_class',
  'classAdded': 'class_added',
  'joinClass': 'clicked_join_class',
  'startBaseline': 'clicked_start_baseline',
  'startEndline': 'clicked_start_endline',
  'clickedNextStory': 'clicked_next_story',
  'clickedNotification': 'clicked_notifications',
  'clickedSuggestEdits': 'clicked_suggest_edits',
  'stemResource': 'stem',
  'siteLanguage': 'site_language',
  'clickedInstagram': 'clicked_instagram',
  'clickedLinkedIn': 'clicked_linked_in',
  'clickedYoutube': 'clicked_youtube',
  'clickedGcr': 'clicked_gcr',
  'clickedExplore': 'clicked_explore',
  'nagCta': 'nag_cta',
  'clickedCta': 'clicked_cta',
  'closedCta': 'closed_cta',
  'bookshelfClicked': 'clicked_bookshelf',
  'clickedEdit': 'clicked_edit',
  'clickedDelete': 'clicked_delete',
  'clickedBanner': 'clicked_banner',
  'clickedCategoryCard': 'clicked_category_card',
  'clickedViewProfile': 'clicked_view_profile',
  'clickedUpdateProfile': 'clicked_update_profile',
  'clickedRegisterOrg': 'clicked_register_org',
  'clickedEditProfile': 'clicked_edit_profile_pic',
  'clickedLessonPlan': 'clicked_lesson_plan',
  'clickedItemNotif': 'clicked_item_notification',
  'clickedNews': 'clicked_news',
  'clickedPress': 'clicked_press',
  'learnMore': 'clicked_learn_more',
  'clickedAbout': 'clicked_about',
  'clickedHowToUse': 'clicked_how_to_use',
  'classroomResources': 'clicked_classroom_resources',
  'booksWorksheets': 'clicked_books_worksheets',
  'learningOutcomes': 'clicked_learning_outcomes',
  'progressTrackers': 'clicked_progress_trackers',
  'fileDownloaded': 'file_downloaded',
  'baselineNag': 'baseline_nag',
  'endlineNag': 'endline_nag',
  'storyShare': 'clicked_story_share',
  'readingStrategies': 'clicked_reading_strategies',
  'clickedShare': 'clicked_share',
  'fileViewed': 'file_viewed',
  'videoPlayed': 'video_played',
  'trainingProgramme': 'teacher_training_programme',
  'storyDownload': 'story_download',
  'clickedFilter': 'clicked_filter',
  'clickedHelp': 'clicked_help',
  'clickedBackStory': 'clicked_back_story',
  'clickedHelpDonate': 'clicked_help_donate'
};

export const gaEventLabel = {
  'similarSection': 'similar_section',
  'topHamburgerMenu': 'topHamburgerMenu',
  'mobileBottomBar': 'mobileBottomBar',
  'programLandingPage': 'program_landing_page',
  'exploreThemesButton': 'explore_themes_button',
  'getStartedButton': 'get_started_button',
  'topBarButton': 'top_bar_button',
  'modulePage': 'module_page',
  'exploreButton': 'explore_button',
  'themePage': 'theme_page',
  'userProfilePage': 'user_profile_page',
  'continueButton': 'continue_button',
  'read': 'read',
  'readingProgram': 'reading_programme',
  'readerView': 'reader_view',
  'translate': 'translate',
  'okay': 'okay',
  'skip': 'skip',
  'publish': 'publish',
  'imagesTab': 'images_tab',
  'threeDotMenu': '3_dot_menu',
  'closeMobileTranslate': 'close_mobile_translate',
  'storyPage': 'story_page',
  'readDropdown': 'read_dropdown',
  'format': 'format',
  'startRegistration': 'start_registration',
  'dropOffOTP': 'drop_off_OTP',
  'finishRegistration': 'finish_registration',
  'dropOff': 'drop_off',
  'popup': 'popup',
  'login': 'login',
  'topMenu': 'top_menu',
  'storyDetailsPage': 'story_details_page',
  'bookshelfPage': 'Bookshelf_Page',
  'level': 'level',
  'language': 'language',
  'category': 'category',
  'FAQ': 'FAQ',
  'share': 'Share',
  'resources': 'Resources',
  'story': 'Story',
  'resourcePage': 'Resource Page',
  'levelPage': 'Level Page',
  'filter': 'Filter',
  'voiceTranslate': 'voice_translate',
  'topNav': 'Top Nav',
  'footer': 'footer',
  'openCode': 'Open Code',
  'impact': 'Impact',
  'covidResponse': 'COVID-19 Response',
  'profileStrength': 'profile_strength',
  'image': 'Image',
  'epub': 'epub',
  'individual': 'Individual',
  'bulk': 'Bulk',
  'reco': 'Reco_Panel',
  'progressTracker': 'Progress Tracker',
  'worksheet': 'Worksheet',
  'supplementary': 'Supplementary Reading',
  'resource': 'Resource',
  'parentResource': 'resource',
  'cbse': 'CBSE Campaign Page',
  'cbseWritingContest' : 'CBSE Writing Contest',
  'surveyForm': 'survey_form',
  'storyfinder': 'storyfinder',
  'trending': 'trending_this_week',
  'languagesThisWeek': 'languages_this_week',
  'spotlight': 'spotlight',
  'levels': 'levels',
  'sortedLists': 'sorted-lists',
  'searchedLang': 'searched_language',
  'topLovedstories': 'top_loved_stories',
  'level1': 'level_1_2',
  'level3': 'level_3_4',
  'imageDetails': 'image_details',
  'popularResources': 'popular_resources',
  'classroomReading': 'in_classroom_reading',
  'videoList': 'video_list',
  'shareExperience': 'share_experience',
  'subjectStoryBooks': 'subject_storybooks',
  'topLoved': 'top_loved_stories',
  'popularThemes': 'popular_themes',
  'resourceCr': 'resources',
  'listCr': 'list',
  'clickedSideMenu': 'clicked_side_menu',
  'discoverTabClicked': 'discover_tab_clicked',
  'upGateway': 'user-profile-gateways',
  'cbseBuddingAuthors': 'budding_author_page',
  'sharePage': 'share_this_page',
  'book': 'book',
  'spotilightContent': 'spotlighted_content',
  'theme': 'theme',
  'video': 'video',
  'grade': 'grade',
  'cbseAuthorModal': 'budding_author_modal',
  'gradeLanguage': 'grade_language',
  'bonusResource': 'bonus_resource',
  'buddingAuthorSm': 'budding_author_sm',
  'phase': 'phase',
  'authModal': 'auth_modal',
  'registrationProgress': 'registration_in_progress',
  'closeRegistration': 'close_registration',
  'topic': 'topic',
  'topSection': 'top_section',
  'mainSection': 'main_section',
  'sideMenu': 'side_menu',
  'lists': 'lists',
  'exploreTheme': 'explore_theme',
  'enrollment': 'enrollment',
  'certificate': 'certificate',
  'quickViewModal': 'quick_view_modal',
  'searchTerm': 'search_term',
  'international': 'international',
  'indian': 'indian',
  'offlineLibrary': 'offline_library',
  'allTabs': 'all_tabs',
  'createClassroomHome': 'create_classroom_home',
  'createClassroom': 'create_classroom',
  'code': 'code',
  'socialAction': 'social_action',
  'bookshelf': 'bookshelf',
  'exploreSimilar': 'explore_similar',
  'translateNow': 'translate_now',
  'translateOffline': 'translate_offline',
  'moreActions': 'more_actions',
  'storyModal': 'story_modal',
  'youMayLike': 'you_may_also_like',
  'deleteOffline': 'delete_confirmation',
  'original': 'original',
  'profilePage': 'profile_page',
  'confirmModal': 'confirmation_modal',
  'bookLangLevel': 'book_language_level',
  'nextModal': 'next_story_modal',
  'readerClose': 'book_reader_closed',
  'nextStoryButton': 'next_story_button',
  'ratingModal': 'rating_modal',
  'nextStorySuggestions': 'next_story_suggestions',
  'nextReadSuggestions': 'next_read_suggestions',
  'follow': 'follow',
  'localization': 'localization',
  'socialMedia': 'social_media',
  'newBookAlert': 'new_book_alert',
  'shareThemePage': 'share_theme_page',
  'bottomSection': 'bottom_section',
  'detailsPage': 'details_page',
  'backMenu': 'back_menu',
  'mobileApp': 'mobile_app',
  'storyweaverGcr': 'storyweaver',
  'programInformation': 'program_information',
  'entrypoint': 'entrypoint',
  'programHomepage': 'program_homepage',
  'filetype': 'filetype',
  'allBooksPage': 'all_books_page',
  'readoutVideo': 'readout_video',
  'help': 'help',
  'visualStorytelling': 'visual_storytelling',
  'banner': 'banner'
}

export const gaReadSource = {
  'recommendedStories': 'recommended_for_you',
  'featuredStories': 'featured_stories',
  'mostRead': 'most_read',
  'newArrivals': 'new_arrivals',
  'awardWinning': 'award_winning',
  'readPage': 'read_page',
  'storyDetailsPage': 'story_details_page',
  'listPage': 'list_page',
  'readingProgram': 'reading_programme',
  'offlineLibrary': 'offline_library',
  'myBookshelf': 'my_bookshelf',
  'translatePage': 'translate_home',
  'csf': 'csf',
  'ece': 'ece',
  'flpHome': 'flp-at-home',
  'stem': 'stem',
  'embed': 'embed'
}

export const gaRpModule = ['new_readers', 'early_readers', 'middle_readers', 'advanced_readers']
export const themeArray = [1, 2, 3, 4, 5, 6]

export const userCategoryEventLabel = {
  'a': 'one_read',
  'b': 'three_reads',
  'c': 'legacy'
}

export const showLinkStatus = {
  'more': 'More',
  'less': 'Less'
}

export const sectionClicked = {
  'bookCard': 'Book Card',
  'bookCardIcon': 'Book Card Icon',
  'bookCardLink': 'Book Card Link',
  'bookDetails': 'Book Details',
  'quickViewModal': 'Quick View Modal',
  'nextReadCard': 'Next Read Card',
  'nextReadButton': 'Next Read Button',
  'allStories': 'All Stories',
  'similarBooks': 'Similar Books',
  'editorPicks': 'Editors picks',
  'mostReads': 'Most Read',
  'newArrivals': 'Recent Arrivals',
  'awardWinning': 'Award Winning',
  'homeRecommendation': 'Home Recommendation',
  'illustrationSearchPage': 'Illustration Search Page',
  'allImagesPage': 'All Images Page',
  'illustrationDetails': 'Illustration Details',
  'illustrationExpandedSearchPage': 'Illustration Expanded Search Page',
  'ListPageBookCard': 'List Page Book Card',
  'ListPageBookTitle': 'List Page Book Title',
  'translateBtn': 'translateButton',
  'translationModal': 'Translation Modal',
  'storyPage': 'StoryPage',
  'translatePage': 'TranslatePage',
  'overAll': 'Overall',
  'nonEnglishLanguage': 'non English Language',
  'orgList': 'OrgList',
  'shareWhatsapp': 'ShareWhatsapp',
  'shareTwitter': 'ShareTwitter',
  'shareFacebook': 'ShareFacebook',
  'nextListRead': 'List Next Read',
  'levellingFrameWork': 'Levelling Framework',
  'instructionalRoutine': 'Instructional Routines',
  'aboutProgramme': 'About Programme',
  'howToUse': 'How to Use',
  'levelPage': 'Level Page',
  'homePage': 'Home Page',
  'programOverviewPage': 'Program Overview Page',
  'readAloud': 'Read Aloud',
  'sharedReading': 'Shared Reading',
  'guidedReading': 'Guided Reading',
  'independentReading': 'Independent Reading',
  'poster': "Poster",
  'lessonPlan': 'Lesson Plan',
  'additionalResources': 'Additional Resources',
  'irPoster': 'IR Poster',
  'themePage': 'Theme Page',
  'posterPage': 'Conversation Poster Page',
  'videoPage': 'Video Page',
  'shareTelegram': 'ShareTelegram',
  'worksheet': 'Worksheet',
  'storyfinderRead': 'Storyfinder Read',
  'topicPage': 'topic page',
  'educatorResources': 'educator resources'
};

export const linkType = {
  'createdBy': 'Created by',
  'translatedBy': 'Translated by',
  'writtenBy': 'Written by',
  'illustratedBy': 'Illustrated by',
  'photographedBy': 'Photograph by',
  'paintedBy': 'Painting by',
  'animatedBy': "Animation by",
  'calligraphedBy': 'Calligraphed By',
  'originalStory': 'original Story'
};

export const bookDownloadFormats = {
  'pdf': 'PDF',
  'ePub': 'ePub',
  'text': 'Text Only',
  'hiResPdf': 'HiRes PDF'
};

export const imageDownloadFormats = {
  'jpeg': 'JPEG',
  'hiResJpeg': 'HiRes JPEG'
};

export const swCookies = {
  'consent': 'sw-consent',
};

export const bookStatus = {
  'published': 'published'
};

export const pageURLString = {
  'readingProgramme': 'reading-programme'
};

export const pageType = {
  'storyPage': 'StoryPage'
}

export const readingProgramImages = {
  onboardingImageURL: 'https://static.storyweaver.org.in/reading_programme/RP_Enroll_Image.png',
  sideImageURL: 'https://static.storyweaver.org.in/reading_programme/sideImage.png',
  studentEnrol: 'https://static.storyweaver.org.in/static_pages/images/flp_how_to_use_banner_image-.png'
};

export const horizontalScreenImages = {
  'first': 'https://storage.googleapis.com/story-weaver-e2e-production/coachmarks/screen1.png',
  'second': 'https://storage.googleapis.com/story-weaver-e2e-production/coachmarks/screen2.png',
  'third': 'https://storage.googleapis.com/story-weaver-e2e-production/coachmarks/screen3.png',
};


export const verticalScreenImages = {
  'first': 'https://static.storyweaver.org.in/suggest_edit_images/vertical_screen1.png',
  'second': 'https://static.storyweaver.org.in/suggest_edit_images/vertical_screen2.png',
  'third': 'https://storage.googleapis.com/story-weaver-e2e-production/coachmarks/vertical_screen3.png',
};

export const authorHorizontalScreenImages = {
  'first': 'https://storage.googleapis.com/story-weaver-e2e-production/coachmarks/author_screen1.png',
  'second': 'https://storage.googleapis.com/story-weaver-e2e-production/coachmarks/author_screen2.png'
};

export const authorVerticalScreenImages = {
  'first': 'https://storage.googleapis.com/story-weaver-e2e-production/coachmarks/author_vertical_screen1.png',
  'second': 'https://static.storyweaver.org.in/suggest_edit_images/author_vertical_screen2.png'
};

export const userProfileImage = {
  image: "https://static.storyweaver.org.in/reading_programme/hello.png"
}

export const gaEventWhitelistedFilters = ['level', 'publisher', 'category', 'language', 'style', 'theme'];

export const SUGGEST_EDIT_LANGUAGES = ["Telugu" , "Spanish" , "Italian" , "Bengali", "Assamese", "Konkani" , "Maithili", "Kannada" ];

export const licenses = [{ name: 'CC BY 4.0', queryValue: 'CC BY 4.0' }];
export const EMBED_ORG_DIRECT_LINK = ['5205']

export const illustrator_type = [
  { name: 'Animator', queryValue: 'Animator' },
  { name: 'Calligrapher', queryValue: 'Calligrapher' },
  { name: 'Illustrator', queryValue: 'Illustrator' },
  { name: 'Painter', queryValue: 'Painter' },
  { name: 'Photographer', queryValue: 'Photographer' }
];

// Sorry, kids!
export const MAX_OFFLINE_BOOKS_COUNT = 36
export const MAX_BULK_DOWNLOAD_BOOKS_COUNT = 10
export const MAX_BULK_DOWNLOAD_IMAGES_COUNT = 10
export const MAX_ZOOM = 5
export const MIN_ZOOM = 1
export const MAX_BOOKSHELF_COUNT = 15
export const CBSE_CONTEST_MIN = 5
export const CBSE_CONTEST_MAX = 5

// The keys here should be the exact strings that the server returns
// in a book's `language` field.
//
// Additionally, the font-family should be mentioned in the variable
// `$font-family-rare-language-fallbacks` in the file `_design-tokens.scss`.
export const fontUrls = {
  Gujarati: 'https://fonts.googleapis.com/earlyaccess/notosansgujarati.css',
  'English-Gujarati': 'https://fonts.googleapis.com/earlyaccess/notosansgujarati.css',
  'English-Kutchi (Gujarati Script)': 'https://fonts.googleapis.com/earlyaccess/notosansgujarati.css',
  'Bhilori (Gujarati Script)': 'https://fonts.googleapis.com/earlyaccess/notosansgujarati.css',
  'Kutchi (Gujarati Script)': 'https://fonts.googleapis.com/earlyaccess/notosansgujarati.css',

  Kannada: 'https://fonts.googleapis.com/earlyaccess/notosanskannada.css',
  'English-Kannada': 'https://fonts.googleapis.com/earlyaccess/notosanskannada.css',

  Telugu: 'https://fonts.googleapis.com/earlyaccess/notosanstelugu.css',
  'English-Telugu': 'https://fonts.googleapis.com/earlyaccess/notosanstelugu.css',

  Odia: 'https://fonts.googleapis.com/earlyaccess/notosansoriyaui.css',
  'English-Odia': 'https://fonts.googleapis.com/earlyaccess/notosansoriyaui.css',
  'Juanga-Odia': 'https://fonts.googleapis.com/earlyaccess/notosansoriyaui.css',
  'Kui-Odia': 'https://fonts.googleapis.com/earlyaccess/notosansoriyaui.css',
  'Munda-Odia': 'https://fonts.googleapis.com/earlyaccess/notosansoriyaui.css',
  'Saura-Odia': 'https://fonts.googleapis.com/earlyaccess/notosansoriyaui.css',

  Tamil: 'https://fonts.googleapis.com/earlyaccess/notosanstamil.css',
  'English-Tamil': 'https://fonts.googleapis.com/earlyaccess/notosanstamil.css',

  Marathi: 'https://fonts.googleapis.com/earlyaccess/notosansdevanagari.css',
  'English-Marathi': 'https://fonts.googleapis.com/earlyaccess/notosansdevanagari.css',

  Hindi: 'https://fonts.googleapis.com/earlyaccess/notosansdevanagari.css',
  'English-Hindi': 'https://fonts.googleapis.com/earlyaccess/notosansdevanagari.css',
  'Van Gujjari (Devanagari Script)': 'https://fonts.googleapis.com/earlyaccess/notosansdevanagari.css',

  Tibetan: 'https://fonts.googleapis.com/earlyaccess/notosanstibetan.css',
  Punjabi: 'https://fonts.googleapis.com/earlyaccess/notosansgurmukhi.css',
  Sinhala: 'https://fonts.googleapis.com/earlyaccess/notosanssinhala.css',
  'Santali (Ol Chiki)': 'https://fonts.googleapis.com/earlyaccess/notosansolchiki.css',
  Bhoti: 'https://fonts.googleapis.com/earlyaccess/notosanstibetan.css',
  'Chakma (RibengUni Script)': 'https://storage.googleapis.com/production-fonts/NotoSansChakma/NotoSansChakma.css',
  'Kashmiri': 'https://story-weaver-e2e-production.storage.googleapis.com/production-fonts/PersoArabicUI/Regular/Afan_Koshur_Naksh.ttf',
  'Manipuri (Meetei Mayek Script)': 'https://fonts.googleapis.com/earlyaccess/notosansmeeteimayek.css'
};

export const countries = [
  { name: "Afghanistan", queryValue: "Afghanistan" },
  { name: "Aland Islands", queryValue: "Aland Islands" },
  { name: "Albania", queryValue: "Albania" },
  { name: "Algeria", queryValue: "Algeria" },
  { name: "American Samoa", queryValue: "American Samoa" },
  { name: "Andorra", queryValue: "Andorra" },
  { name: "Angola", queryValue: "Angola" },
  { name: "Anguilla", queryValue: "Anguilla" },
  { name: "Antarctica", queryValue: "Antarctica" },
  { name: "Antigua and Barbuda", queryValue: "Antigua and Barbuda" },
  { name: "Argentina", queryValue: "Argentina" },
  { name: "Armenia", queryValue: "Armenia" },
  { name: "Aruba", queryValue: "Aruba" },
  { name: "Australia", queryValue: "Australia" },
  { name: "Austria", queryValue: "Austria" },
  { name: "Azerbaijan", queryValue: "Azerbaijan" },
  { name: "Bahamas", queryValue: "Bahamas" },
  { name: "Bahrain", queryValue: "Bahrain" },
  { name: "Bangladesh", queryValue: "Bangladesh" },
  { name: "Barbados", queryValue: "Barbados" },
  { name: "Belarus", queryValue: "Belarus" },
  { name: "Belgium", queryValue: "Belgium" },
  { name: "Belize", queryValue: "Belize" },
  { name: "Benin", queryValue: "Benin" },
  { name: "Bermuda", queryValue: "Bermuda" },
  { name: "Bhutan", queryValue: "Bhutan" },
  { name: "Bolivia", queryValue: "Bolivia" },
  { name: "Bonaire, Sint Eustatius And Saba", queryValue: "Bonaire, Sint Eustatius And Saba" },
  { name: "Bosnia and Herzegovina", queryValue: "Bosnia and Herzegovina" },
  { name: "Botswana", queryValue: "Botswana" },
  { name: "Br. Indian Ocean Ter.", queryValue: "Br. Indian Ocean Ter." },
  { name: "Brazil", queryValue: "Brazil" },
  { name: "Brunei Darussalam", queryValue: "Brunei Darussalam" },
  { name: "Bulgaria", queryValue: "Bulgaria" },
  { name: "Burkina Faso", queryValue: "Burkina Faso" },
  { name: "Burundi", queryValue: "Burundi" },
  { name: "Cambodia", queryValue: "Cambodia" },
  { name: "Cameroon", queryValue: "Cameroon" },
  { name: "Canada", queryValue: "Canada" },
  { name: "Cape Verde", queryValue: "Cape Verde" },
  { name: "Cayman Islands", queryValue: "Cayman Islands" },
  { name: "Central African Rep.", queryValue: "Central African Rep." },
  { name: "Chad", queryValue: "Chad" },
  { name: "Chile", queryValue: "Chile" },
  { name: "China", queryValue: "China" },
  { name: "Christmas Island", queryValue: "Christmas Island" },
  { name: "Cocos (Keeling) Islands", queryValue: "Cocos (Keeling) Islands" },
  { name: "Colombia", queryValue: "Colombia" },
  { name: "Comoros", queryValue: "Comoros" },
  { name: "Congo (Dem. Rep.)", queryValue: "Congo (Dem. Rep.)" },
  { name: "Congo (Rep.)", queryValue: "Congo (Rep.)" },
  { name: "Cook Islands", queryValue: "Cook Islands" },
  { name: "Costa Rica", queryValue: "Costa Rica" },
  { name: "Côte d'Ivoire", queryValue: "Côte d'Ivoire" },
  { name: "Croatia", queryValue: "Croatia" },
  { name: "Cuba", queryValue: "Cuba" },
  { name: "Curacao", queryValue: "Curacao" },
  { name: "Cyprus", queryValue: "Cyprus" },
  { name: "Czech Republic", queryValue: "Czech Republic" },
  { name: "Denmark", queryValue: "Denmark" },
  { name: "Djibouti", queryValue: "Djibouti" },
  { name: "Dominica", queryValue: "Dominica" },
  { name: "Dominican Republic", queryValue: "Dominican Republic" },
  { name: "Ecuador", queryValue: "Ecuador" },
  { name: "Egypt", queryValue: "Egypt" },
  { name: "El Salvador", queryValue: "El Salvador" },
  { name: "Equatorial Guinea", queryValue: "Equatorial Guinea" },
  { name: "Eritrea", queryValue: "Eritrea" },
  { name: "Estonia", queryValue: "Estonia" },
  { name: "Ethiopia", queryValue: "Ethiopia" },
  { name: "Falkland Is. (Malvinas)", queryValue: "Falkland Is. (Malvinas)" },
  { name: "Faröe Islands", queryValue: "Faröe Islands" },
  { name: "Fiji", queryValue: "Fiji" },
  { name: "Finland", queryValue: "Finland" },
  { name: "France", queryValue: "France" },
  { name: "French Guiana", queryValue: "French Guiana" },
  { name: "French Polynesia", queryValue: "French Polynesia" },
  { name: "French Southern Territories", queryValue: "French Southern Territories" },
  { name: "Gabon", queryValue: "Gabon" },
  { name: "Gambia", queryValue: "Gambia" },
  { name: "Georgia", queryValue: "Georgia" },
  { name: "Germany", queryValue: "Germany" },
  { name: "Ghana", queryValue: "Ghana" },
  { name: "Gibraltar", queryValue: "Gibraltar" },
  { name: "Greece", queryValue: "Greece" },
  { name: "Greenland", queryValue: "Greenland" },
  { name: "Grenada", queryValue: "Grenada" },
  { name: "Guadeloupe", queryValue: "Guadeloupe" },
  { name: "Guam", queryValue: "Guam" },
  { name: "Guatemala", queryValue: "Guatemala" },
  { name: "Guernsey", queryValue: "Guernsey" },
  { name: "Guinea", queryValue: "Guinea" },
  { name: "Guinea-Bissau", queryValue: "Guinea-Bissau" },
  { name: "Guyana", queryValue: "Guyana" },
  { name: "Haiti", queryValue: "Haiti" },
  { name: "Honduras", queryValue: "Honduras" },
  { name: "Hong Kong", queryValue: "Hong Kong" },
  { name: "Hungary", queryValue: "Hungary" },
  { name: "Iceland", queryValue: "Iceland" },
  { name: "India", queryValue: "India" },
  { name: "Indonesia", queryValue: "Indonesia" },
  { name: "Iran", queryValue: "Iran" },
  { name: "Iraq", queryValue: "Iraq" },
  { name: "Ireland", queryValue: "Ireland" },
  { name: "Isle of Man", queryValue: "Isle of Man" },
  { name: "Israel", queryValue: "Israel" },
  { name: "Italy", queryValue: "Italy" },
  { name: "Jamaica", queryValue: "Jamaica" },
  { name: "Japan", queryValue: "Japan" },
  { name: "Jersey", queryValue: "Jersey" },
  { name: "Jordan", queryValue: "Jordan" },
  { name: "Kazakhstan", queryValue: "Kazakhstan" },
  { name: "Kenya", queryValue: "Kenya" },
  { name: "Kiribati", queryValue: "Kiribati" },
  { name: "Korea (Dem. Rep.)", queryValue: "Korea (Dem. Rep.)" },
  { name: "Korea (Rep.)", queryValue: "Korea (Rep.)" },
  { name: "Kuwait", queryValue: "Kuwait" },
  { name: "Kyrgyzstan", queryValue: "Kyrgyzstan" },
  { name: "Laos", queryValue: "Laos" },
  { name: "Latvia", queryValue: "Latvia" },
  { name: "Lebanon", queryValue: "Lebanon" },
  { name: "Lesotho", queryValue: "Lesotho" },
  { name: "Liberia", queryValue: "Liberia" },
  { name: "Libya", queryValue: "Libya" },
  { name: "Liechtenstein", queryValue: "Liechtenstein" },
  { name: "Lithuania", queryValue: "Lithuania" },
  { name: "Luxembourg", queryValue: "Luxembourg" },
  { name: "Macao", queryValue: "Macao" },
  { name: "Macedonia, TFYR", queryValue: "Macedonia, TFYR" },
  { name: "Madagascar", queryValue: "Madagascar" },
  { name: "Malawi", queryValue: "Malawi" },
  { name: "Malaysia", queryValue: "Malaysia" },
  { name: "Maldives", queryValue: "Maldives" },
  { name: "Mali", queryValue: "Mali" },
  { name: "Malta", queryValue: "Malta" },
  { name: "Marshall Islands", queryValue: "Marshall Islands" },
  { name: "Martinique", queryValue: "Martinique" },
  { name: "Mauritania", queryValue: "Mauritania" },
  { name: "Mauritius", queryValue: "Mauritius" },
  { name: "Mayotte", queryValue: "Mayotte" },
  { name: "Mexico", queryValue: "Mexico" },
  { name: "Micronesia", queryValue: "Micronesia" },
  { name: "Moldova", queryValue: "Moldova" },
  { name: "Monaco", queryValue: "Monaco" },
  { name: "Mongolia", queryValue: "Mongolia" },
  { name: "Montenegro", queryValue: "Montenegro" },
  { name: "Montserrat", queryValue: "Montserrat" },
  { name: "Morocco", queryValue: "Morocco" },
  { name: "Mozambique", queryValue: "Mozambique" },
  { name: "Myanmar", queryValue: "Myanmar" },
  { name: "Namibia", queryValue: "Namibia" },
  { name: "Nauru", queryValue: "Nauru" },
  { name: "Nepal", queryValue: "Nepal" },
  { name: "Netherlands", queryValue: "Netherlands" },
  { name: "New Caledonia", queryValue: "New Caledonia" },
  { name: "New Zealand", queryValue: "New Zealand" },
  { name: "Nicaragua", queryValue: "Nicaragua" },
  { name: "Niger", queryValue: "Niger" },
  { name: "Nigeria", queryValue: "Nigeria" },
  { name: "Niue", queryValue: "Niue" },
  { name: "Norfolk Island", queryValue: "Norfolk Island" },
  { name: "Northern Mariana Islands", queryValue: "Northern Mariana Islands" },
  { name: "Norway", queryValue: "Norway" },
  { name: "Oman", queryValue: "Oman" },
  { name: "Pakistan", queryValue: "Pakistan" },
  { name: "Palau", queryValue: "Palau" },
  { name: "Palestinian Territory", queryValue: "Palestinian Territory" },
  { name: "Panama", queryValue: "Panama" },
  { name: "Papua New Guinea", queryValue: "Papua New Guinea" },
  { name: "Paraguay", queryValue: "Paraguay" },
  { name: "Peru", queryValue: "Peru" },
  { name: "Philippines", queryValue: "Philippines" },
  { name: "Pitcairn", queryValue: "Pitcairn" },
  { name: "Poland", queryValue: "Poland" },
  { name: "Portugal", queryValue: "Portugal" },
  { name: "Puerto Rico", queryValue: "Puerto Rico" },
  { name: "Qatar", queryValue: "Qatar" },
  { name: "Réunion", queryValue: "Réunion" },
  { name: "Romania", queryValue: "Romania" },
  { name: "Russia", queryValue: "Russia" },
  { name: "Rwanda", queryValue: "Rwanda" },
  { name: "S. Georgia and S. Sandwich", queryValue: "S. Georgia and S. Sandwich" },
  { name: "Saint Helena", queryValue: "Saint Helena" },
  { name: "Saint Lucia", queryValue: "Saint Lucia" },
  { name: "Saint Martin", queryValue: "Saint Martin" },
  { name: "Saint Pierre and Miquelon", queryValue: "Saint Pierre and Miquelon" },
  { name: "Saint-Barthélemy", queryValue: "Saint-Barthélemy" },
  { name: "Samoa", queryValue: "Samoa" },
  { name: "San Marino", queryValue: "San Marino" },
  { name: "Sao Tomé and Principe", queryValue: "Sao Tomé and Principe" },
  { name: "Saudi Arabia", queryValue: "Saudi Arabia" },
  { name: "Senegal", queryValue: "Senegal" },
  { name: "Serbia", queryValue: "Serbia" },
  { name: "Seychelles", queryValue: "Seychelles" },
  { name: "Sierra Leone", queryValue: "Sierra Leone" },
  { name: "Singapore", queryValue: "Singapore" },
  { name: "Sint Maarten", queryValue: "Sint Maarten" },
  { name: "Slovakia", queryValue: "Slovakia" },
  { name: "Slovenia", queryValue: "Slovenia" },
  { name: "Solomon Islands", queryValue: "Solomon Islands" },
  { name: "Somalia", queryValue: "Somalia" },
  { name: "South Africa", queryValue: "South Africa" },
  { name: "South Sudan", queryValue: "South Sudan" },
  { name: "Spain", queryValue: "Spain" },
  { name: "Sri Lanka", queryValue: "Sri Lanka" },
  { name: "St. Kitts and Nevis", queryValue: "St. Kitts and Nevis" },
  { name: "St. Vincent and Grenadines", queryValue: "St. Vincent and Grenadines" },
  { name: "Sudan", queryValue: "Sudan" },
  { name: "Suriname", queryValue: "Suriname" },
  { name: "Svalbard and Jan Mayen", queryValue: "Svalbard and Jan Mayen" },
  { name: "Swaziland", queryValue: "Swaziland" },
  { name: "Sweden", queryValue: "Sweden" },
  { name: "Switzerland", queryValue: "Switzerland" },
  { name: "Syria", queryValue: "Syria" },
  { name: "Taiwan", queryValue: "Taiwan" },
  { name: "Tajikistan", queryValue: "Tajikistan" },
  { name: "Tanzania", queryValue: "Tanzania" },
  { name: "Thailand", queryValue: "Thailand" },
  { name: "Timor-Leste", queryValue: "Timor-Leste" },
  { name: "Togo", queryValue: "Togo" },
  { name: "Tokelau", queryValue: "Tokelau" },
  { name: "Tonga", queryValue: "Tonga" },
  { name: "Trinidad and Tobago", queryValue: "Trinidad and Tobago" },
  { name: "Tunisia", queryValue: "Tunisia" },
  { name: "Turkey", queryValue: "Turkey" },
  { name: "Turkmenistan", queryValue: "Turkmenistan" },
  { name: "Turks and Caicos Is.", queryValue: "Turks and Caicos Is." },
  { name: "Tuvalu", queryValue: "Tuvalu" },
  { name: "Uganda", queryValue: "Uganda" },
  { name: "Ukraine", queryValue: "Ukraine" },
  { name: "United Arab Emirates", queryValue: "United Arab Emirates" },
  { name: "United Kingdom", queryValue: "United Kingdom" },
  { name: "United States Minor Outlying Islands", queryValue: "United States Minor Outlying Islands" },
  { name: "United States of America", queryValue: "United States of America" },
  { name: "United States Virgin Islands", queryValue: "United States Virgin Islands" },
  { name: "Uruguay", queryValue: "Uruguay" },
  { name: "Uzbekistan", queryValue: "Uzbekistan" },
  { name: "Vanuatu", queryValue: "Vanuatu" },
  { name: "Vatican City", queryValue: "Vatican City" },
  { name: "Venezuela", queryValue: "Venezuela" },
  { name: "Viet Nam", queryValue: "Viet Nam" },
  { name: "Virgin Islands, British", queryValue: "Virgin Islands, British" },
  { name: "Wallis and Futuna", queryValue: "Wallis and Futuna" },
  { name: "Western Sahara", queryValue: "Western Sahara" },
  { name: "Yemen", queryValue: "Yemen" },
  { name: "Zambia", queryValue: "Zambia" },
  { name: "Zimbabwe", queryValue: "Zimbabwe" }
];

export const operatingSystems = {
  macosPlatforms: ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
  windowsPlatforms: ['Win32', 'Win64', 'Windows', 'WinCE'],
  iosPlatforms: ['iPhone', 'iPad', 'iPod'],
  macOS: 'Mac OS',
  iOS: 'iOS',
  windows: 'Windows',
  android: 'Android',
  linux: 'Linux'
}

export const readingProgram = {
  continue: 'continue',
  notStarted: 'not_started',
  finished: 'finished',
  siteHeaderLinks: {
    english: { label: "English", value: 'en' },
    hindi: { label: "Hindi", value: 'hi' },
    french: { label: "French", value: "fr" },
    farsi: { label: "Farsi", value: "fa" },
    arabic: { label: "Arabic", value: "ar" },
    marathi: { label: "Marathi", value: "mr" },
    urdu: { label: "Urdu", value: "ur" },
    konkani:{label:"Konkani",value:"kok"}
  },
  heading: "Share a few details about your school",
  subHeading: "If you don’t have this information, do get in touch with your school administration",
  thirdQuerySubText: "For multiple grades, do share the total number of students",
  cbseRegions: ["Ajmer", "Prayagraj", "Bhubaneswar", "Chennai", "Dehradun", "Delhi East", "Delhi West", "Guwahati", "Panchkula", "Patna", "Pune", "Thiruvananthapuram", "Chandigarh", "Noida", "Bhopal", "Bangalore"],
  cbseNonIndiaRegions: ["Delhi East"],
  levelOfSchool: ["Secondary", "Senior Secondary"],
  typeOfSchool: ["Government", "Government Aided", "Independent", "Kendriya Vidyalaya (KV)", "Jawahar Navodaya Vidyalaya (JNV)", "Tibetan School"],
  cbseCountries: ["India", "Afghanistan", "Bahrain", "Bangladesh", "Burma", "Ethiopia", "Indonesia", "Iran", "Japan", "Kuwait", "Libya", "Malaysia", "Nepal", "Nigeria", "Oman", "Qatar", "Benin", "Saudi Arabia", "Singapore", "Tanzania", "Thailand", "Russia", "UAE", "Uganda", "Yeman", "West Africa"],
  selectCountry: "Select country",
  selectState: "Select state",
  selectDistrict: "Select district",
  country: "Country",
  district: "District",
  state: "State",
  selectType: "Select type",
  selectLevel: "Select level",
  selectRegion: "Select CBSE region",
  schoolType: "School type",
  schoolLevel: "School level",
  cbseRegion: "CBSE region",
  affiliationNo: "School Affiliation Number",
  cbseSchoolNo: "CBSE School Number",
  cbseQuery: "Are you participating in the CBSE Reading Mission?",
  cbseSubText: "(Only for teachers at CBSE-affiliated schools)",
  cbseStudentText: "(Only for students of CBSE-affiliated schools)",
  cbseLibText: "(Only for librarians from CBSE-affiliated schools)",
  rpError: "Error! Please recheck the number.",
  rpBookshelfLinks: {
    engNew: 'https://storyweaver.org.in/lists/280275-new-readers-grades-1-and-2',
    engEarly: 'https://storyweaver.org.in/lists/280272-early-readers-grades-3-and-4',
    engMiddle: 'https://storyweaver.org.in/lists/280273-middle-readers-grades-5-and-6',
    engAdv: 'https://storyweaver.org.in/lists/280274-advanced-readers-grades-7-and-8',
    hindiNew: 'https://storyweaver.org.in/lists/280277-1-2',
    hindiEarly: 'https://storyweaver.org.in/lists/280283-3-4',
    hindiMiddle: 'https://storyweaver.org.in/lists/280284-5-6',
    hindiAdv: 'https://storyweaver.org.in/lists/280285-7-8'
  },
  downloadPercentage: 100,
  enrollmentTypes : {
    teacher: "Teacher",
    student: "Student",
    coordinator: "Co-ordinator",
    parent: "Parent",
    librarian: "Librarian",
  },
  fluenceArr: ["New Readers", "Early Readers", "Middle Readers", "Advanced Readers"],
  cbse: "cbse_rp",
  goa: "goa_rp",
  private: "Private",
  selectCampaign: "Select campaign",
  selectBlock: "Select block",
  rpTextError: "Error! Can not be empty.",
  udiseText: "(applicable for Govt & Aided schools)",
  goaState: "Goa",
  government: "Government",
  primary: "Primary",
  parent: "Parent",
  coOrdinator: "Co-ordinator",
  student: "Student",
  comingSoon: "جلد آرہا ہے"
}

export const flpHomeData = {
  countries: ["India", "Non-India"],
  animation: 'https://static.storyweaver.org.in/flp_at_home/gifs/Done_Animation.gif',
  dummyJotforms: {
    flpBaseline: {
      hi: {
        1: 'https://form.jotform.com/233030773310443',
        2: 'https://form.jotform.com/233032015085443',
        3: 'https://form.jotform.com/233032500089446',
      },
      mr: {
        1: 'https://form.jotform.com/233030773310443',
        2: 'https://form.jotform.com/233032015085443',
        3: 'https://form.jotform.com/233032500089446',
      }
    },
    flpEndline: {
      hi: {
        1: 'https://form.jotform.com/233032615139449',
        2: 'https://form.jotform.com/233031118658452',
        3: 'https://form.jotform.com/233031046451443',
      },
      mr: {
        1: 'https://form.jotform.com/233032615139449',
        2: 'https://form.jotform.com/233031118658452',
        3: 'https://form.jotform.com/233031046451443',
      }
    },
    baseline: 'https://form.jotform.com/230453113378451',
    endline: 'https://form.jotform.com/232352354702449',
    worksheet: {
      "mr": {
        1: {
          1: "https://form.jotform.com/240648333838463",
          2: "https://form.jotform.com/240648052026450",
          3: "https://form.jotform.com/240648640047456",
          4: "https://form.jotform.com/240648064127455",
          5: "https://form.jotform.com/240647909422460",
          6: "https://form.jotform.com/240648735720459",
          7: "https://form.jotform.com/240648542997471",
          8: "https://form.jotform.com/240647969873476",
          9: "https://form.jotform.com/240648528218461",
          10:"https://form.jotform.com/240648673544464",
        },
        2: {
          1: "https://form.jotform.com/240648524073456",
          2: "https://form.jotform.com/240648403938462",
          3: "https://form.jotform.com/240648061512450",
          4: "https://form.jotform.com/240648689118468",
          5: "https://form.jotform.com/240648560010447",
          6: "https://form.jotform.com/240648530752457",
          7: "https://form.jotform.com/240648281762461",
          8: "https://form.jotform.com/240648701173454",
          9: "https://form.jotform.com/240648862252460",
          10:"https://form.jotform.com/240648175571461",     
        },
        3: {
          1: "https://form.jotform.com/240648180431452",
          2: "https://form.jotform.com/240648089591467",
          3: "https://form.jotform.com/240648204237453",
          4: "https://form.jotform.com/240648765662467",
          5: "https://form.jotform.com/240648128058459",
          6: "https://form.jotform.com/240648784782471",
          7: "https://form.jotform.com/240648646482465",
          8: "https://form.jotform.com/240648726285465",
          9: "https://form.jotform.com/240648781980468",
          10:"https://form.jotform.com/240648165779470",
        }
      },
      "hi": {
        1: {
          1: "https://form.jotform.com/241092583961461",
          2: "https://form.jotform.com/241092203529450",
          3: "https://form.jotform.com/241092791369464",
          4: "https://form.jotform.com/241092578656466",
          5: "https://form.jotform.com/241092203529450",
          6: "https://form.jotform.com/230520689993467",
          7: "https://form.jotform.com/230520689993467",
          8: "https://form.jotform.com/230520689993467",
          9: "https://form.jotform.com/230520689993467",
          10:"https://form.jotform.com/230520689993467",
        },
        2: {
          1: "https://form.jotform.com/230520689993467",
          2: "https://form.jotform.com/241092857646465",
          3: "https://form.jotform.com/241092472476459",
          4: "https://form.jotform.com/241093029970457",
          5: "https://form.jotform.com/241093141358452",
          6: "https://form.jotform.com/241092179752460",
          7: "https://form.jotform.com/230520689993467",
          8: "https://form.jotform.com/230520689993467",
          9: "https://form.jotform.com/230520689993467",
          10:"https://form.jotform.com/230520689993467",
        },
        3: {
          1: "https://form.jotform.com/230520689993467",
          2: "https://form.jotform.com/241092941612452",
          3: "https://form.jotform.com/241092271844455",
          4: "https://form.jotform.com/241092442399460",
          5: "https://form.jotform.com/241092707740454",
          6: "https://form.jotform.com/241092822436454",
          7: "https://form.jotform.com/230520689993467",
          8: "https://form.jotform.com/230520689993467",
          9: "https://form.jotform.com/230520689993467",
          10:"https://form.jotform.com/230520689993467",
        }
      }
    },
    worksheetDefault: 'https://form.jotform.com/230520689993467',
    milestone: {
      1: 'https://form.jotform.com/220951865700052',
      2: 'https://form.jotform.com/220951865700052',
      3: 'https://form.jotform.com/220951960533456',
      4: 'https://form.jotform.com/220952375040450',
      5: 'https://form.jotform.com/221583478783469',
    },
    flpBaselineOneToMany: {
      hi: {
        1: 'https://form.jotform.com/233090880229457',
        2: 'https://form.jotform.com/233091293006449',
        3: 'https://form.jotform.com/233091286912457',
      },
      mr: {
        1: 'https://form.jotform.com/233091018426450',
        2: 'https://form.jotform.com/233392288512459',
        3: 'https://form.jotform.com/233392153862458',
      }
    },
    flpEndlineOneToMany: {
      hi: {
        1: 'https://form.jotform.com/233090870106450',
        2: 'https://form.jotform.com/233091829428462',
        3: 'https://form.jotform.com/233090892199466',
      },
      mr: {
        1: 'https://form.jotform.com/233091271196455',
        2: 'https://form.jotform.com/233392546968471',
        3: 'https://form.jotform.com/233392456933463',
      }
    },
    stemMooc: {
      en: "https://form.jotform.com/231301246824447",
      hi:  "https://form.jotform.com/240292687372463",
    },
    baselineOneToMany: "https://form.jotform.com/230453113378451",
    endlineOneToMany: "https://form.jotform.com/231212026599453",
    flpMooc: {
      1: 'https://form.jotform.com/233541796423460',
      2: 'https://form.jotform.com/233541840228453',
      3: 'https://form.jotform.com/233542133037447',
      default: 'https://form.jotform.com/231411584165452'
    },
  }
}

export const csf = {
  siteHeaderLinks: {
    hindi: { label: "Hindi", value: 'hi' },
    marathi: { label: "Marathi", value: 'mr' },
  }
}

export const csfLangs = {
  hi: 'Hindi',
  en: 'English',
  mr: 'Marathi'
}

export const flpHome = {
  siteHeaderLinks: {
    hindi: { label: "Hindi", value: 'hi' },
    marathi: { label: "Marathi", value: 'mr' },
  }
}

export const stemHome = {
  siteHeaderLinks: {
    english: { label: "English", value: 'en', disable: false },
    hindi: { label: "Hindi", value: 'hi', disable: false },
    marathi: { label: "Marathi", value: 'mr', disable: false},
    odia: { label: "Odia", value: 'or', disable: false },
    urdu: { label: "Urdu", value: 'ur', disable: false },
  }
}

export const flpHomeLangs = {
  hi: 'Hindi',
  en: 'English'
}

export const flpHomeAboutUrls = ['about', 'how-to-use', 'classroom-resources', 'books-worksheets', 'learning-outcomes', 'progress-trackers']

export const csfRoutines = {
  'ra': 'read-aloud',
  'sr': 'shared-reading',
  'gr': 'guided-reading',
  'ir': 'independent-reading'
}
// TODO: get text direction with languages
export const rtlLanguages = ["Arabic", "English-Farsi (Samim)", "English-Urdu", "Farsi", "Farsi (Samim)", "Hebrew", "Kurdish (Arabic Script)", "Pashto", "Punjabi (Urdu script)", "Urdu", "Kashmiri"]
export const quillpadLanguages = ["Bengali", "Gujarati", "Hindi", "Kannada", "Marathi", "Punjabi", "Tamil", "Telugu", "Chhattisgarhi", "Surgujia", "Sahariya"]
export const devNagriScript = ["Chhattisgarhi", "Surgujia", "Sahariya"]
export const vernamLanguages = ["Odia", "Malayalam", "Sanskrit", "Assamese"]
export const ai4BharatLanguages = ["Konkani", "Maithili", "Bodo", "Nepali", "Kashmiri", "Urdu", "Manipuri (Meetei Mayek Script)"]

export const defaultAppLanguages = [
  { name: 'English', queryValue: 'en' },
];

export const otherAppLanguages = [
  { name: 'فارسی', queryValue: 'fa' },
  { name: 'हिंदी', queryValue: 'hi' },
  { name: 'मराठी', queryValue: 'mr' },
  { name: 'Español', queryValue: 'es' },
  { name: 'Français', queryValue: 'fr' },
  { name: 'عربي', queryValue: 'ar' },
  { name: 'اردو', queryValue: 'ur' },
  { name: 'ଓଡିଆ', queryValue: 'or' },
  {name: 'कोंकणी', queryValue: 'kok'}
];

export const appLanguages = [
  { name: 'English', queryValue: 'en' },
  { name: 'فارسی', queryValue: 'fa' },
  { name: 'हिंदी', queryValue: 'hi' },
  { name: 'मराठी', queryValue: 'mr' },
  { name: 'Español', queryValue: 'es' },
  { name: 'Français', queryValue: 'fr' },
  { name: 'عربي', queryValue: 'ar' },
  { name: 'اردو', queryValue: 'ur' },
  { name: 'ଓଡିଆ', queryValue: 'or' },
  {name: 'कोंकणी', queryValue: 'kok'}
];

export const siteLocaleLanguages = ['en', 'fr', 'es', 'ar', 'ur', 'or', 'fa', 'hi', 'mr', 'kok']

export const organizations = {
  storyweaver_community: "StoryWeaver Community",
  storyweaver: "Storyweaver"
}

export const translateAPILocaleList = ["fr", "es", "ar", "fa", "or"];
export const donateImages = {
  popup: 'https://static.storyweaver.org.in/donate/popup.png',
  mobPopup: 'https://static.storyweaver.org.in/donate/mob-popup.png',
  seasonPopup: 'https://static.storyweaver.org.in/donate/images/donateMobile.jpg',
  seasonMobPopup: 'https://static.storyweaver.org.in/donate/images/donate.jpg',
  desktopBg: 'https://static.storyweaver.org.in/static/images/donate_lcd_banner_desktop.png',
  desktopBg2: 'https://static.storyweaver.org.in/donate/desktop-bg2.png',
  mobBg: 'https://static.storyweaver.org.in/static/images/donate_lcd_banner_mobile.png',
  mobBg2: 'https://static.storyweaver.org.in/donate/mob-bg2.png',
  sub1: 'https://static.storyweaver.org.in/donate/sub1.png',
  sub2: 'https://static.storyweaver.org.in/donate/sub2.png',
  sub3: 'https://static.storyweaver.org.in/donate/sub3.png',
  sub4: 'https://static.storyweaver.org.in/donate/sub4.png',
  section: 'https://static.storyweaver.org.in/static/images/donate_section_desktop.png',
  mobSection: 'https://static.storyweaver.org.in/static/images/donate_section_mobile.png',
  rightArrow: 'https://static.storyweaver.org.in/donate/right-arrow.png',
  downArrow: 'https://static.storyweaver.org.in/donate/down-arrow.png',
  shareBanner: 'https://static.storyweaver.org.in/static/images/Donate_share_section_boy_desktop.png',
  mobShareBanner: 'https://static.storyweaver.org.in/static/images/donate_share_section_boy_mobile.png',
  supportUs: 'https://static.storyweaver.org.in/international_donors/header_image_for_international_donor_form.png',
  ptrPopup: 'https://static.storyweaver.org.in/static_pages/images/ptr-learn-more.png',
  ptrPopupM: 'https://static.storyweaver.org.in/static_pages/images/ptr-learn-moreM.png',
  donate23: 'https://static.storyweaver.org.in/static_pages/images/donate_2023.png',
  donatePopup1: "https://static.storyweaver.org.in/static/images/donate-popup1.png",
  donatePopup2: "https://static.storyweaver.org.in/static/images/donate-popup2.png"
};

export const donateNavLinks = [
  { id: "crisis", label: "The crisis" },
  { id: "efforts", label: "Our efforts" },
  { id: "donate-section", label: "Donate" },
  { id: "faqs", label: "FAQs" },
  { id: "about", label: "About us" },
];

export const trendingLanguages = ["English", "Tamil", "Kannada", "Hindi", "Bahasa Indonesia", "Punjabi", "Marathi", "Lakota", "French"]

export const menuPageSelected = {
  'main': 'main',
  'user': 'user',
  'read': 'read',
  'resources': 'resources',
  'bottomResources': 'bottom-resources',
  'readingProgram': 'reading-program',
  'siteLang': 'site-language',
  'bookLists': 'book-lists',
  'csf': 'csf',
  'ece': 'ece',
  'flpHome': 'flp-home',
  'discover': 'discover',
  'stem': 'stem',
  'gcr': 'gcr',
  'bottomGcr': 'bottom-gcr',
  'mobSiteLang': 'mobile-site-language'
}

export const googleCloudLang = [
  { lang: 'Hindi', bcpValue: 'hi-IN' },
  { lang: 'Tamil', bcpValue: 'ta-IN' },
  { lang: 'Marathi', bcpValue: 'mr-IN' },
  { lang: 'English', bcpValue: 'en-IN' },
]

export const sampleRate = 44100
export const desiredSampRate = 16000
export const numberOfAudioChannels = 1
export const maxRecordTime = 5000

export const staticPages = [
  { key: "our-story", value: "Our Story" },
  { key: "impact", value: "Impact" },
  { key: "covid-19-response", value: "COVID-19 Response" },
  { key: "open-philosophy", value: "Open Philosophy" },
  { key: "campaigns", value: "Campaigns" },
  { key: "goshticha", value: "Goshticha Shaniwar" },
  { key: 'stemCampaign', value: 'STEM_campaign_main_content'},
  { key: 'news', value: 'News'}
]
export const minBooksForNextReads = 5;
export const nagCounter = 3;

export const ecePages = {
  'landing': 'landing',
  'themes': 'themes',
  'posters': 'conversation_posters',
  'videos': 'videos'
}

export const ece = {
  siteHeaderLinks: {
    hindi: { label: "Hindi", value: 'hi' },
  }
}

export const eceLangs = {
  hi: 'Hindi',
  en: 'English'
}

export const eceThemes = {
  'ide': 'Identity and Relationships',
  'int': 'Introducing Concepts',
  'our': 'Our World',
  'soc': 'Social Surroundings',
  'sta': 'Staying Well',
  'won': 'Wonderful Nature'
}
export const defaultImages = {
  'onEmptyBgImage': 'https://static.storyweaver.org.in/static_pages/watering-can.svg',
  'onEmptyBgImageSelf': 'https://static.storyweaver.org.in/static_pages/hand-with-pencil.svg',
  'onEmptyBookshelf': 'https://static.storyweaver.org.in/static_pages/girl-with-book.png',
  'read': 'https://static.storyweaver.org.in/suggest_edit_images/icon.png'
}

export const contactImages = {
  'headCardImage': 'https://static.storyweaver.org.in/contact_page/images/robo-lang.png',
  'branchCardImage': 'https://static.storyweaver.org.in/contact_page/images/children-reading.png'
}

export const csfImages = {
  'shadowImage': 'https://static.storyweaver.org.in/static_pages/image3.png',
  'categoryLine': 'https://static.storyweaver.org.in/static_pages/category-line.png'
}

export const mtImages = {
  'loadingImage': 'https://static.storyweaver.org.in/static_pages/loadingPage.png',
  'mobileBookInfoImage': 'https://static.storyweaver.org.in/static_pages/bookInfoLoadingPage.png',
  'defaultThumbnailImage': 'https://static.storyweaver.org.in/static_pages/plain-white-background.jpg',
  'headerLogo': 'https://static.storyweaver.org.in/static_pages/header-logo.svg'
}

export const staticPageImages = {
  ourStory: {
    'spOurStoryBanner': 'https://static.storyweaver.org.in/static_pages/ourStoryBanner.png',
    'kidReadingBook': 'https://static.storyweaver.org.in/static_pages/kidReadingBook.png',
    'section3_1': 'https://static.storyweaver.org.in/static_pages/section3_1.png',
    'section3_2': 'https://static.storyweaver.org.in/static_pages/section3_2.png',
    'section3_3': 'https://static.storyweaver.org.in/static_pages/section3_3.png',
    'graphicGirlReading': 'https://static.storyweaver.org.in/static_pages/graphic-girl-reading.png',
    'slate': 'https://static.storyweaver.org.in/static_pages/slate.png',
    'belowImage': 'https://static.storyweaver.org.in/static_pages/slateBelow.png',
    'belowImageMobile': 'https://static.storyweaver.org.in/static_pages/slateMobile.png'
  },
  impact: {
    'spImpactPageB1': 'https://static.storyweaver.org.in/static_pages/sp-impact-b1.png',
    'spImpactPageB2': 'https://static.storyweaver.org.in/static_pages/sp-impact-b2.png',
    'spImpactPageB3': 'https://static.storyweaver.org.in/static_pages/sp-impact-b3-new.png',
    'spImpactPageB4': 'https://static.storyweaver.org.in/static_pages/sp-impact-b4-new.png',
    'spImpactPageB5': 'https://static.storyweaver.org.in/static_pages/sp-impact-b5-new.png',
    'spImpactPageB6': 'https://static.storyweaver.org.in/static_pages/images/sp-impact-b6.png',
    'spImpactPageB7': 'https://static.storyweaver.org.in/static_pages/images/sp-impact-b7.png'
  },
  openPhilosophy: {
    'spOpenContentTab': 'https://static.storyweaver.org.in/static_pages/sp-open-content.png',
    'spOpenToolsTab': 'https://static.storyweaver.org.in/static_pages/sp-open-tools.png',
    'spOpenCodeTab': 'https://static.storyweaver.org.in/static_pages/sp-open-code.png',
    'spOpenContentPageB1': 'https://static.storyweaver.org.in/static_pages/sp-open-content-b1.png',
    'spOpenContentPageMobileB1': 'https://static.storyweaver.org.in/static_pages/sp-open-content-mobile-b1.png',
    'openTool1': 'https://static.storyweaver.org.in/static_pages/open-tool-1.png',
    'openTool2': 'https://static.storyweaver.org.in/static_pages/open-tool-2.png',
  },
  covidResponse: {
    'spCovid19Image1': 'https://static.storyweaver.org.in/static_pages/sp-covid-19-b1.png',
    'spCovid19Image2': 'https://static.storyweaver.org.in/static_pages/sp-covid-19-b2.png',
    'spCovid19Image3': 'https://static.storyweaver.org.in/static_pages/sp-covid-19-b3.png',
  },
  campaigns: {
    'spCampaignsImage1': 'https://static.storyweaver.org.in/static_pages/sp-campaigns-b1.png',
    'moKahaani': 'https://static.storyweaver.org.in/static_pages/images/mo_kahani_1.jpg',
    'moKahaani2': 'https://static.storyweaver.org.in/static_pages/images/mo_kahani_2.jpg',
    'prevCampaign': 'https://static.storyweaver.org.in/static_pages/previousCampaigns.png',
    'gostichaCampaign': 'https://static.storyweaver.org.in/static_pages/gosticha.png',
    'gostichaBanner': 'https://static.storyweaver.org.in/static_pages/Goshticha Shaniwar_campaign-desktop.png',
    'cbseCampaign': 'https://storyweaver-sw2-full.storage.googleapis.com/cbse/Campaign_listing_v2.png',
    'cbseCampaignBanner': 'https://static.storyweaver.org.in/reading_programme/cbse_campaign_page_desktop_image.png',
    'flpCampaign': 'https://static.storyweaver.org.in/static_pages/campaign_icon.png',
    'flpCampaignBanner': 'https://static.storyweaver.org.in/static_pages/campaign_banner_image.png',
    'flpInClass': 'https://static.storyweaver.org.in/static_pages/in_class_image.png',
    'flpAtHome': 'https://static.storyweaver.org.in/static_pages/read_at_home_image.png',
    'flpMH2': 'https://static.storyweaver.org.in/static_pages/read-at-home-maharashtra.png',
    'flpMH': 'https://static.storyweaver.org.in/static_pages/read-at-home-maharshtra-2.png',
    'cbseTable': 'https://static.storyweaver.org.in/cbse_contest_reading_level_table.png',
    'cbseContest': '',
    'explore': 'https://static.storyweaver.org.in/images/sp-explore.png',
    'spExploreSeo1': 'https://static.storyweaver.org.in/user_gateways/images/spExploreSeo1.png',
    'spExploreSeo2': 'https://static.storyweaver.org.in/user_gateways/images/spExploreSeo2.png',
    'spExploreSeo3': 'https://static.storyweaver.org.in/user_gateways/images/spExploreSeo3.png',
    'spExploreSeo4': 'https://static.storyweaver.org.in/user_gateways/images/spExploreSeo4.png',
    'spExploreSeo5': 'https://static.storyweaver.org.in/user_gateways/images/spExploreSeo5.png',
    'spExploreSeo6': 'https://static.storyweaver.org.in/user_gateways/images/spExploreSeo6.png',
    'spExploreSeo7': 'https://static.storyweaver.org.in/user_gateways/images/spExploreSeo7.png',
    'spExploreSeo8': 'https://static.storyweaver.org.in/user_gateways/images/spExploreSeo8.png',
    'cbseBuddingProgram' : 'https://static.storyweaver.org.in/static_pages/images/cbse-budding-program.png',
    'cbseYoungChild' : 'https://static.storyweaver.org.in/static_pages/images/young-child.png',
    'cbseLogo': 'https://static.storyweaver.org.in/static_pages/images/cbse-logo.png',
    'seoComicsImg': 'https://static.storyweaver.org.in/seo/images/seo-comics-page.png',
    'seoHistoryImg': 'https://static.storyweaver.org.in/seo/images/seo-history-page.png',
    'seoDetetiveImg': 'https://static.storyweaver.org.in/seo/images/seo-detective-page.png',
    'seoSpaceImg': 'https://static.storyweaver.org.in/seo/images/seo-space-page.png',
    'odiaRpSupportBanner': 'https://static.storyweaver.org.in/static_pages/images/sp_odia_rp_support.png',
    'campaignModalBottomLeft':'https://static.storyweaver.org.in/static_pages/images/bottom_left_odia_rp_modal.png',
    'campaignModalTopLeft':'https://static.storyweaver.org.in/static_pages/images/top_left_odia_rp_modal.png',
    'campaignModalRight':'https://static.storyweaver.org.in/static_pages/images/right_odia_rp_modal.png',
    'campaignModalBackground':'https://static.storyweaver.org.in/static_pages/images/odia_rp_modal_background.png',
    'odiaRpCampaignLogo':'https://static.storyweaver.org.in/static_pages/images/odisha_rp_logo.png',
    'stemCampaign': 'https://static.storyweaver.org.in/jotform/images/Thumbnail-girl.png',
    'stemAsset': 'https://static.storyweaver.org.in/jotform/images/Tool.png',
    'stemCampaignBanner': 'https://static.storyweaver.org.in/campaign/images/STEMLP-CP-DeskBanner.png',
    'stemImg1': 'https://static.storyweaver.org.in/campaign/images/Final-Storychart-Image.png',
    'stemImg2': 'https://static.storyweaver.org.in/campaign/images/Story-based-learning-example-Jadhav.png',
    'stemImg3': 'https://static.storyweaver.org.in/campaign/images/STEM-Framework-Image-GIF.gif',
    'pledgeBoy': 'https://static.storyweaver.org.in/static_pages/images/pledge-boy.png',
    'pledgeGirl': 'https://static.storyweaver.org.in/static_pages/images/pledge-girl.png',
    'pledgeCurveBg': 'https://static.storyweaver.org.in/static_pages/images/pledge-curve-bg.png',
    'pledgeBook': 'https://static.storyweaver.org.in/static_pages/images/pledge-book.png',
    'pledgeBirds': 'https://static.storyweaver.org.in/static_pages/images/pledge-birds.png',
    'birdThread': 'https://static.storyweaver.org.in/static_pages/images/birdThread.png',
    'treeGif': 'https://static.storyweaver.org.in/static_pages/images/Tree.gif',
    'swingGif': 'https://static.storyweaver.org.in/static_pages/images/Swing.gif',
    'pledgeShare': 'https://static.storyweaver.org.in/static_pages/images/pledge-share.png',
    'pledgeBgBook': 'https://static.storyweaver.org.in/static_pages/images/book.png',
    'slateBelowPledge': 'https://static.storyweaver.org.in/static_pages/images/slateBelowPledge.png',
    'stars': 'https://static.storyweaver.org.in/static_pages/images/stars.gif',
    'sharePartner': 'https://static.storyweaver.org.in/static_pages/images/sharePartner.png',
    'partnerWithUs': 'https://static.storyweaver.org.in/campaign/images/partnerWithUs.png',
    'pledgeBanner': 'https://static.storyweaver.org.in/static_pages/images/pledge-banner.png',
    'pledgeBannerM': "https://static.storyweaver.org.in/static_pages/images/pledgeBannerM.png",
    'gcrBanner': "https://static.storyweaver.org.in/static_pages/images/gcrBanner.png",
    'gcrBannerM': 'https://static.storyweaver.org.in/static_pages/images/gcrBannerM.png',
    'monthlyEvents': 'https://static.storyweaver.org.in/static_pages/images/monthlyEvents.png',
    'pledgeSlateBelow': 'https://static.storyweaver.org.in/static_pages/images/pledge-below-slate.png',
    'pledgeSlateD': 'https://static.storyweaver.org.in/static_pages/images/pledge-slate.png',
    'pledgeSlateM': "https://static.storyweaver.org.in/static_pages/images/slateM.png",
    'pledgeCloud': 'https://static.storyweaver.org.in/static_pages/images/pledge-cloud.png',
    'shareLaugh': 'https://static.storyweaver.org.in/static_pages/images/share-laugh.png',
    'heroEllipse': 'https://static.storyweaver.org.in/static_pages/images/heroEllipse.png',
    'pledgeRightEvent': 'https://static.storyweaver.org.in/static_pages/images/ptr-right-event.png',
    'pledgeLeftEvent': 'https://static.storyweaver.org.in/static_pages/images/ptr-left-event.png',
    'swLogo': 'https://storage.googleapis.com/storyweaver-sw2-full/strapi/Story_Weaver_logo_1_2_1c9621bea0/Story_Weaver_logo_1_2_1c9621bea0.png',
    'highlight': "https://static.storyweaver.org.in/static_pages/images/highlights.png",
    'numbers' : {
      'number1': 'https://static.storyweaver.org.in/static_pages/images/1.png',
      'number2': 'https://static.storyweaver.org.in/static_pages/images/2.png',
      'number3': 'https://static.storyweaver.org.in/static_pages/images/3.png',
    },
    'pledgeBlueBar': 'https://static.storyweaver.org.in/static_pages/images/pledge-blue-bar.png',
    'girlBook': 'https://static.storyweaver.org.in/ptr/images/girlBook.png',
    'tooltip': 'https://static.storyweaver.org.in/ptr/images/tooltip.png',
    'tooltipM': 'https://static.storyweaver.org.in/ptr/images/tooltipM.png',
    'ptrCloudSun': 'https://static.storyweaver.org.in/static_pages/images/ptr-cloud-sun.png',
    'pledgeCloudSunM': 'https://static.storyweaver.org.in/static_pages/images/ptr-cloud-sunM.png',
    'ptrCloud': 'https://static.storyweaver.org.in/static_pages/images/ptr-cloud.png',
    'ptrCap': 'https://static.storyweaver.org.in/static_pages/images/ptr-cap.png',
    'ptrBlueSlate': 'https://static.storyweaver.org.in/static_pages/images/ptr-blue-slate.png',
    'ptrSun': 'https://static.storyweaver.org.in/static_pages/images/ptr-sun.png',
    'ptrBlueSlateM': 'https://static.storyweaver.org.in/static_pages/images/ptr-blue-slateM.png',
    'ptrOdos': 'https://static.storyweaver.org.in/static_pages/images/ptr_odos.png',
    'spot1': 'https://storage.googleapis.com/static.storyweaver.org.in/strapi/hero_bl_9f50f2e8d6/hero_bl_9f50f2e8d6.png',
    'spot2': 'https://static.storyweaver.org.in/static_pages/images/spot2.png',
    'gcr': 'https://static.storyweaver.org.in/static_pages/images/gtr.png',
    'gcrPartner': 'https://static.storyweaver.org.in/static_pages/images/gtrpartner.png',
    'stemSearchBanner': 'https://static.storyweaver.org.in/static_pages/images/StemSearchBanner.png',
    'stemSearchBannerM': 'https://static.storyweaver.org.in/stem_static/StemSearchBannerM.png',
    'championCertD': 'https://static.storyweaver.org.in/static_pages/images/championCertD.png',
    'superHeroCertM': 'https://static.storyweaver.org.in/static_pages/images/superHeroCertM.png',
    'readingChampionM': 'https://static.storyweaver.org.in/static_pages/images/readingChampionM.png',
    'championCertM': 'https://static.storyweaver.org.in/static_pages/images/championCertM.png',
    'readingSuperHeroM': 'https://static.storyweaver.org.in/static_pages/images/readingSuperHeroM.png',
    'readingJourney': 'https://static.storyweaver.org.in/static_pages/images/readingJourney.png',
    'starCertM': 'https://static.storyweaver.org.in/static_pages/images/starCertM.png',
    'radingStarM': 'https://static.storyweaver.org.in/static_pages/images/radingStarM.png',
    'starCertD': 'https://static.storyweaver.org.in/static_pages/images/starCertD.png',
    'superHeroCertD': 'https://static.storyweaver.org.in/static_pages/images/superHeroCertD.png',
    'newStarCertD': 'https://static.storyweaver.org.in/static_pages/images/newStarCertD.png',
    'newChampionCertD': 'https://static.storyweaver.org.in/static_pages/images/newChampionCertD.png',
    'newSuperHeroCertD': 'https://static.storyweaver.org.in/static_pages/images/newSuperHeroCertD.png',
    'stemSearchBannerRtlM': 'https://static.storyweaver.org.in/static_pages/images/StemSearchBannerRtlM.png',
    'flpTeacherModalImg': 'https://static.storyweaver.org.in/static_pages/images/flp_home_teacher_enrol_pop_up.png',
    'radingChampRtlM': 'https://static.storyweaver.org.in/static_pages/images/radingChampRtlM.png',
    'readingJourneyRtl': 'https://static.storyweaver.org.in/static_pages/images/readingJourneyRtl.png',
    'superHeroRtlCertD': 'https://static.storyweaver.org.in/static_pages/images/superHeroRtlCertD.png',
    'championRtlCertD': 'https://static.storyweaver.org.in/static_pages/images/championRtlCertD.png',
    'radingStarRtlM': 'https://static.storyweaver.org.in/static_pages/images/radingStarRtlM.png',
    'radingSupHeroRtlM': 'https://static.storyweaver.org.in/static_pages/images/radingSupHeroRtlM.png',
    'starRtlCertD': 'https://static.storyweaver.org.in/static_pages/images/starRtlCertD.png',
    'flpAllBooksBannerM': 'https://static.storyweaver.org.in/static_pages/images/flp-all-books-bannerM.png',
    'flpAllBooksBanner': 'https://static.storyweaver.org.in/static_pages/images/flp-all-books-banner.png',
    'allImpactsImg': 'https://static.storyweaver.org.in/static_pages/allImpactsImg.jpg',
    'odos': 'https://static.storyweaver.org.in/static/images/odos_logo.png',
    'odosBlueSlate': 'https://static.storyweaver.org.in/static/images/odos-blue-slate.png'
  },
  specialAssets   : {
    'asset1' : 'https://static.storyweaver.org.in/static_pages/sp-asset-1.png',
    'asset2' : 'https://static.storyweaver.org.in/static_pages/sp-asset-2.png',
    'asset3' : 'https://static.storyweaver.org.in/static_pages/sp-asset-3.png',
    'asset4' : 'https://static.storyweaver.org.in/static_pages/sp-asset-4.png',
    'asset5' : 'https://static.storyweaver.org.in/static_pages/sp-asset-5.png',
    'asset6' : 'https://static.storyweaver.org.in/static_pages/sp-asset-6.png',
    'asset7' : 'https://static.storyweaver.org.in/static_pages/sp-asset-7.png',
    'asset8' : 'https://static.storyweaver.org.in/static_pages/sp-asset-8.png',
    'asset9' : 'https://static.storyweaver.org.in/static_pages/sp-asset-9.png',
    'asset10' : 'https://static.storyweaver.org.in/static_pages/images/cbse-bird.png',
  },
  common: {
    'spImpactPageB6': 'https://static.storyweaver.org.in/static_pages/sp-impact-b6.png',
    'spImpactPageB9': 'https://static.storyweaver.org.in/static_pages/sp-our-story-donate.png',
    'spImpactPageB7': 'https://static.storyweaver.org.in/static_pages/clouds-left.png',
    'spImpactPageB8': 'https://static.storyweaver.org.in/static_pages/clouds-right.png',
    'spCovid19Cloud1': 'https://static.storyweaver.org.in/static_pages/sp-covid-19-cloud1.png',
    'spCovid19Cloud2': 'https://static.storyweaver.org.in/static_pages/sp-covid-19-cloud2.png',
    'spCovid19Cloud3': 'https://static.storyweaver.org.in/static_pages/sp-covid-19-cloud3.png',
    'spCovid19Cloud4': 'https://static.storyweaver.org.in/static_pages/sp-covid-19-cloud4.png',
  },
  educatorClassroom: {
    "classroomIdeas": "https://static.storyweaver.org.in/user_gateway/images/IdeasForClassroom.png",
  },
  news: {
    'bannerImg': 'https://static.storyweaver.org.in/static_pages/images/NewBanner1.png',
    'bannerImgD': 'https://static.storyweaver.org.in/static/images/news-bannerD.png'
  },
  logoGif : 'https://static.storyweaver.org.in/static_pages/images/sw-logo.gif',
  gcrImpact: {
    oneStar: 'https://static.storyweaver.org.in/static_pages/images/impact-one-star.png',
    twoStar: 'https://static.storyweaver.org.in/static_pages/images/impact-two-star.png',
    fourStar: 'https://static.storyweaver.org.in/static_pages/images/impact-four-star.png',
    quote: 'https://static.storyweaver.org.in/static_pages/images/impact-quote.png'
  },
  faqs : {
    bannerDesktop : 'https://static.storyweaver.org.in/static_pages/images/faq_banner_desktop.png',
    bannerMobile : 'https://static.storyweaver.org.in/static_pages/images/faq_banner_mobile.png',
  },
  awards : {
    bannerDesktop : "https://static.storyweaver.org.in/static_pages/images/awards-banner-image.png",
    bannerMobile : "https://static.storyweaver.org.in/static_pages/images/awards-banner-mobile.png"
  },
  careers : {
    bannerImg : 'https://static.storyweaver.org.in/static/images/sp_career_banner.png',
  },
};

export const cbseProgram = {
  continue: 'started',
  notStarted: 'not_started',
  finished: 'finished'
}
export const userGatewayImages = {
  'trending': {
    'number1': "https://static.storyweaver.org.in/user_gateways/images/1.png",
    'number2': "https://static.storyweaver.org.in/user_gateways/images/2.png",
    'number3': "https://static.storyweaver.org.in/user_gateways/images/3.png",
    'number4': "https://static.storyweaver.org.in/user_gateways/images/4.png",
    'number5': "https://static.storyweaver.org.in/user_gateways/images/5.png",
    'number6': "https://static.storyweaver.org.in/user_gateways/images/6.png",
    'number7': "https://static.storyweaver.org.in/user_gateways/images/7.png",
    'number8': "https://static.storyweaver.org.in/user_gateways/images/8.png",
    'number9': "https://static.storyweaver.org.in/user_gateways/images/9.png",
    'number10': "https://static.storyweaver.org.in/user_gateways/images/10.png",
  },
  'bannerDesktop': "https://static.storyweaver.org.in/user_gateways/images/SW_Homepage_Banner.png",
  'bannerMobile': "https://static.storyweaver.org.in/user_gateways/images/SW_Mobile_Banner.png",
  'studentDesktop': "https://static.storyweaver.org.in/user_gateways/images/Student-Gateway-Banner-Desktop.jpg",
  'studentMobile': "https://static.storyweaver.org.in/user_gateways/images/Student-Gateway-Banner-Mobile.jpg",
  "blend": "https://static.storyweaver.org.in/user_gateways/images/blend.png",
  "level1": "https://static.storyweaver.org.in/user_gateways/images/level1.png",
  "level2": "https://static.storyweaver.org.in/user_gateways/images/level2.png",
  "level3": "https://static.storyweaver.org.in/user_gateways/images/level3.png",
  "level4": "https://static.storyweaver.org.in/user_gateways/images/level4.png",
  "level5": "https://static.storyweaver.org.in/user_gateways/images/level5.png",
  "sky": "https://static.storyweaver.org.in/user_gateways/images/sky.png",
  "storyfinder": "https://static.storyweaver.org.in/user_gateways/images/storyfinder.png",
  "world": "https://static.storyweaver.org.in/user_gateways/images/world.png",
  "ctaStudent": "https://static.storyweaver.org.in/user_gateway/images/student.png",
  "ctaParent": "https://static.storyweaver.org.in/user_gateway/images/parent.png",
  "ctaEducator": "https://static.storyweaver.org.in/user_gateway/images/educator.png",
  "resource1": "https://static.storyweaver.org.in/user_gateway/images/resource1.png",
  "resource2": "https://static.storyweaver.org.in/user_gateway/images/resource2.png",
  "resource3": "https://static.storyweaver.org.in/user_gateway/images/resource3.png",
  "resource4": "https://static.storyweaver.org.in/stem_static_pages/images/stem-resource.png",
  "bird1": "https://static.storyweaver.org.in/user_gateway/images/Educatorhome1.png",
  "bird2": "https://static.storyweaver.org.in/user_gateway/images/bird2.png",
  "bird3": "https://static.storyweaver.org.in/user_gateway/images/bird3.png",
  "engageBird": "https://static.storyweaver.org.in/user_gateways/images/Engagebird.png",
  "slateBelow": "https://static.storyweaver.org.in/user_gateways/images/slateBelow.png",
  "comingSoon": "https://static.storyweaver.org.in/static_pages/images/coming-soon.png"
}

export const excludeCategories = ['Bilingual', 'Created by Children', 'Readalong', 'Story Card']

export const draftRetentionImages = {
  noNotificationImageURL: 'https://static.storyweaver.org.in/draft_retension/images/no_notifications.png',
};

export const userGatewayForms = {
  parent: {
    en: "https://docs.google.com/forms/d/e/1FAIpQLSddRiAjVZ83BmE03IlP1gouYWeZTlAGLGwclGBwi_gNmlo-fA/viewform"
  },
  educator: {
    en: "https://docs.google.com/forms/d/e/1FAIpQLScG30HtZHLVVV5a4FMS4Eaw7WmTKIgTSzUL1Wu2rDf4RxfUFg/viewform?usp=sf_link"
  }
}

export const volunteerForm = {
  volunteerGoogleForm : "https://docs.google.com/forms/d/10Rp76gnmlabOLx04wTmpxe03TjlH-Awo8Y3RxT6Tr5A/viewform"
}

export const staticUserGatewayImages = {
  parent: {
    'bitmapImage1': "https://static.storyweaver.org.in/user_gateway/images/popular_parent_img1.png",
    'bitmapImage2': "https://static.storyweaver.org.in/user_gateway/images/popular_parent_img3.png",
    'bitmapImage3': "https://static.storyweaver.org.in/user_gateway/images/popular_parent_img2.png",
    'shareParentImage': "https://static.storyweaver.org.in/jot_form/images/share_parent.png"
  },
  teacher: {
    'EducatorHome2': "https://static.storyweaver.org.in/user_gateway/images/Educatorhome2.png",
    'EducatorHome3': "https://static.storyweaver.org.in/user_gateway/images/Educatorhome3.png",
    'EducatorHome4': "https://static.storyweaver.org.in/user_gateway/images/Educatorhome4.png",
    'EducatorHome5': "https://static.storyweaver.org.in/user_gateway/images/Educatorhome5.png",
    'EducatorHome6': "https://static.storyweaver.org.in/user_gateway/images/Educatorhome6.png",
    'EducatorHome7': 'https://static.storyweaver.org.in/user_gateway/images/EducatorShare.png',
    'EducatorHome8': 'https://static.storyweaver.org.in/user_gateway/images/EducatorFaq.png',
  },
};

export const userProfileType = {
  PARENT: 'parent',
  TEACHER: 'teacher',
  STUDENT: 'student',
  CREATOR: 'creator',
  ED_ORG: 'ed-org',
  ED_TECH: 'ed-tech',
  OTHERS: 'others',
  LIBRARIAN: 'librarian',
  PUBLISHER: 'publisher',
  STORYTELLER: 'storyteller',
  CURRICULUM_DEVELOPER: 'curriculum developer',
  GOVERNMENT_OFFICIAL: 'government official',
};

export const mapUserGatewayProfileType = {
  [userProfileType.PARENT]: 'parent',
  [userProfileType.STORYTELLER]: 'parent',
  [userProfileType.TEACHER]: 'educator',
  [userProfileType.ED_ORG]: 'educator',
  [userProfileType.ED_TECH]: 'educator',
  [userProfileType.LIBRARIAN]: 'educator',
  [userProfileType.PUBLISHER]: 'educator',
  [userProfileType.CURRICULUM_DEVELOPER]: 'educator',
  [userProfileType.GOVERNMENT_OFFICIAL]: 'educator',
  [userProfileType.STUDENT]: 'student',
  [userProfileType.CREATOR]: 'default',
  [userProfileType.OTHERS]: 'default',
};


export const lpImages = {
  'intro': 'https://static.storyweaver.org.in/stem_program/images/intro.png',
  'activity': 'https://static.storyweaver.org.in/stem_program/images/activity.png',
  'vocab': 'https://static.storyweaver.org.in/stem_program/images/vocab.png',
  'project': 'https://static.storyweaver.org.in/stem_program/images/project.png',
  'more': 'https://static.storyweaver.org.in/stem_program/images/moreStories.png',
  'misconcept': 'https://static.storyweaver.org.in/stem_program/images/misconcept.png',
  'qa': 'https://static.storyweaver.org.in/stem_program/images/qa.png',
  'hots': 'https://static.storyweaver.org.in/stem_program/images/hots.png',
  'example': 'https://static.storyweaver.org.in/stem_program/images/example.png',
  'addon': 'https://static.storyweaver.org.in/stem_program/images/addon.png',
}

export const stemImages = {
    'stemTopicsMath': 'https://static.storyweaver.org.in/stem_program/images/StemTopicMath.png',
    'stemTopicsScience': 'https://static.storyweaver.org.in/stem_program/images/StemTopicScience.png',
    'stemMobileMath': 'https://static.storyweaver.org.in/stem_program/images/science_mobile_bg.png',
    'stemMobileScience': 'https://static.storyweaver.org.in/stem_program/images/maths_mobile_bg.png',
    "stemLogo": "https://static.storyweaver.org.in/stem_programme/images/stemLogo.svg",
    "stemMathLogo": 'https://static.storyweaver.org.in/stem_programme/images/mathsLogo.svg',
    "stemScienceLogo": 'https://static.storyweaver.org.in/stem_programme/images/scienceLogo.svg',
    "stemMathShadow": "https://static.storyweaver.org.in/stem_program/images/mathShadow.png",
    "stemScienceShadow": "https://static.storyweaver.org.in/stem_program/images/scienceShadow.png",
    "headerMaths": "https://static.storyweaver.org.in/stem_programme/images/headerMaths.png",
    "headerScience": "https://static.storyweaver.org.in/stem_programme/images/headerScience.png",
    "stemMathBlue": "https://static.storyweaver.org.in/stem_program/images/mathBlue.png",
    "stemScienceOrange": "https://static.storyweaver.org.in/stem_program/images/scienceOrange.png",
    "bannerD": "https://static.storyweaver.org.in/stem_programme/images/stemBanner.png",
    "bannerM": "https://static.storyweaver.org.in/stem_programme/images/stemBannerM.png",
    "stemFooter": "https://static.storyweaver.org.in/stem_programme/images/stemFooter.png",
    "stemFooterM": "https://static.storyweaver.org.in/stem_programme/images/stemFooterM.png",
    "partner": "https://static.storyweaver.org.in/stem_programme/images/partner.png",
    'sharePage': "https://static.storyweaver.org.in/stem_programme/images/sharePage.png",
    "benefit1": "https://static.storyweaver.org.in/stem_programme/images/stemVocab.png",
    "benefit2": "https://static.storyweaver.org.in/stem_programme/images/stemHots.png",
    "stemSkills": "https://static.storyweaver.org.in/stem_programme/images/stemSkills.png",
    "stemLiteracyBanner": "https://static.storyweaver.org.in/stem_static_pages/images/stem_literacy_banner.png",
    "stemLiteracyBannerM": "https://static.storyweaver.org.in/stem_static_pages/images/stem-literacy-bannerM.png",
    "spOverview1": "https://static.storyweaver.org.in/stem_static_pages/images/stem_programme_overview1.png",
    "spOverview2": "https://static.storyweaver.org.in/stem_static_pages/images/stem_programme_overview2.png",
    "spOverview3": "https://static.storyweaver.org.in/stem_static_pages/images/stem_programme_overview3.png",
    "spOverview4": "https://static.storyweaver.org.in/stem_static_pages/images/stem_programme_overview4.png",
    "spOverview5": "https://static.storyweaver.org.in/stem_static_pages/images/stem_programme_overview5.png",
    "stemSkills1": "https://static.storyweaver.org.in/stem_static_pages/images/stem-skills-img1.png",
    "stemSkillsFramework" : {
      "desktop" : {
        "en": "https://static.storyweaver.org.in/stem_static_pages/images/stem_skills_img2.png",
        "hi": "https://static.storyweaver.org.in/static_pages/images/stem_hindi.png",
        "mr": "https://static.storyweaver.org.in/static_pages/images/stem_marathi.png",
      },
      "mobile" : {
        "en": "https://static.storyweaver.org.in/stem_static_pages/images/stem-skills-img3.png",
        "hi": "https://static.storyweaver.org.in/static_pages/images/stem_hindi_mobile.png",
        "mr": "https://static.storyweaver.org.in/static_pages/images/stem_marathi_mobile.png",
      }
    },
    "stemLE1": "https://static.storyweaver.org.in/stem_static_pages/images/stem_learning_exp1.png",
    "stemLE2": "https://static.storyweaver.org.in/stem_static_pages/images/stem_learning_exp2.png",
    "stemLE3": "https://static.storyweaver.org.in/stem_static_pages/images/stem_learning_exp3.png",
    "stemLE4": "https://static.storyweaver.org.in/stem_static_pages/images/stem_learning_exp4.png",
    "stemLE5": "https://static.storyweaver.org.in/stem_static_pages/images/stem_learning_exp5.png",
    "stemLE6": "https://static.storyweaver.org.in/stem_static_pages/images/stem_learning_exp6.png",
    "stemLE7": "https://static.storyweaver.org.in/stem_static_pages/images/stem_learning_exp7.png",
    "stemLE8": "https://static.storyweaver.org.in/stem_static_pages/images/stem_learning_exp8.png",
    "stemLE9": "https://static.storyweaver.org.in/stem_static_pages/images/stem_learning_exp9.png",
    "stemPO12": "https://static.storyweaver.org.in/stem_static_pages/images/stem-PO12.png",
    "stemPO11": "https://static.storyweaver.org.in/stem_static_pages/images/stem-PO11.png",
    "evsNoData": "https://static.storyweaver.org.in/stem_static_pages/images/evs-no-data.png",
    "stemMoocD": "https://static.storyweaver.org.in/stem_program/images/stemMoocD.png",
    "stemMoocM": "https://static.storyweaver.org.in/stem_program/images/stemMoocMbl.png",
    "stemMoocModule" : "https://static.storyweaver.org.in/stem_program/images/StemMoocBanner.png",
    "stemMoocModuleM": "https://static.storyweaver.org.in/stem_program/images/stemMoocM.png",
    "stemTopicHero": "https://static.storyweaver.org.in/stem_program/images/stem_topics_hero_img.png",
    "stemTopicMaths": "https://static.storyweaver.org.in/stem_program/images/maths_bg.png",
    "stemTopicScience": "https://static.storyweaver.org.in/stem_program/images/science_bg.png",
    "stemTopicMathsM": "https://static.storyweaver.org.in/stem_program/images/mobile_maths_bg.png",
    "stemTopicScienceM": "https://static.storyweaver.org.in/stem_program/images/mobile_science_bg.png",
    "flpMoocD": "https://static.storyweaver.org.in/flp_mooc/images/flpMoocD.png",
    "flpMoocM": "https://static.storyweaver.org.in/flp_mooc/images/flpMoocM.png",
    "flpMoocModuleD": "https://static.storyweaver.org.in/flp_mooc/images/flpMoocModuleD.png",
    "stemCert": "https://static.storyweaver.org.in/campaign/images/stemCertificate.png",
    "stemMoocRetry": "https://static.storyweaver.org.in/stem_mooc/images/stem-mooc-retry.png",

    stemTopicHeaderBgUrl: {
      source: [
        { width: "max-width: 480px", imgUrl: "https://static.storyweaver.org.in/stem_programme/images/stemTopicsBannerM.png" },
        { width: "min-width: 481px", imgUrl: "https://static.storyweaver.org.in/stem_programme/images/stemTopicsBanner.png" },
      ],
      defaultSrc: "https://static.storyweaver.org.in/stem_programme/images/stemTopicsBanner.png",
      altText: "stem-topic-banner"
    },
    scienceBgUrl: {
      source: [
        { width: "max-width: 480px", imgUrl: "https://static.storyweaver.org.in/stem_programme/images/scienceBannerM.png" },
        { width: "min-width: 481px", imgUrl: "https://static.storyweaver.org.in/stem_programme/images/scienceBanner.png" },
      ],
      defaultSrc: "https://static.storyweaver.org.in/stem_programme/images/scienceBanner.png",
      altText: "stem-topic-banner"
    },
    mathsBgUrl: {
      source: [
        { width: "max-width: 480px", imgUrl: "https://static.storyweaver.org.in/stem_programme/images/MathsBannerM.png" },
        { width: "min-width: 481px", imgUrl: "https://static.storyweaver.org.in/stem_programme/images/MathsBanner.png" },
      ],
      defaultSrc: "https://static.storyweaver.org.in/stem_programme/images/MathsBanner.png",
      altText: "stem-topic-banner"
    },
}

export const stemAboutUrls = ['programme-overview', 'stem-outcome-framework', 'learning-experiences', 'stem-topics', 'teacher-training-module']
export const subjectsStem = ["Maths", "Science & EVS"]

export const campaignTypes = {
  cbse_contest: 'CBSE_CONTEST',
  odia_rp: 'ODIA_RP'
}

export const odiaRpCampaignGradeLevel = {
  "Level 1": '1 & 2',
  "Level 2": '3,4 & 5'
}

export const giveIndiaUrl = "https://give.do/projects/storyweaver-support-us-in-providing-book-security-for-every-child"

export const pledgeLanguages = [
  { name: 'English', queryValue: 'en', label: 'English' },
  { name: 'हिंदी', queryValue: 'hi', label: 'Hindi' },
  { name: 'मराठी', queryValue: 'mr', label: 'Marathi' },
  { name: 'ಕನ್ನಡ', queryValue: 'kn', label: 'Kannada' },
  { name: 'தமிழ்', queryValue: 'ta', label: 'Tamil' },
  { name: 'Español', queryValue: 'es', label: 'Spanish' },
  { name: 'Français', queryValue: 'fr', label: 'French' },
];

export const platformLanguages = [
  { name: 'English', queryValue: 'en', label: 'English' },
  { name: 'हिंदी', queryValue: 'hi', label: 'Hindi' },
  { name: 'मराठी', queryValue: 'mr', label: 'Marathi' },
  { name: 'ಕನ್ನಡ', queryValue: 'kn', label: 'Kannada' },
  { name: 'தமிழ்', queryValue: 'ta', label: 'Tamil' },
  { name: 'Español', queryValue: 'es', label: 'Spanish' },
  { name: 'Français', queryValue: 'fr', label: 'French' },
  { name: 'فارسی', queryValue: 'fa', label: "Farsi" },
  { name: 'عربي', queryValue: 'ar', label: "Arabic"  },
  { name: 'اردو', queryValue: 'ur', label: "Urdu"  },
  { name: 'ଓଡିଆ', queryValue: 'or', label: "Odia"  },
  { name: 'कोंकणी', queryValue: 'kok', label: "Konkani" }
];

export const resourceRtlLanguages = ['ur'];

export const siteUrl = ['https://storyweaver.org.in', 'https://feature2.pbees.party', 'https://feature1.pbees.party', 'https://uat.pbees.party', 'https://dev.pbees.party'];

export const sanitizeHref = (htmlData) => {
  const parser = new DOMParser();
  const el = parser.parseFromString(htmlData, 'text/html');
  const children = [...el.getElementsByTagName('a')];
  children.forEach((child) => { 
  let href  = child.getAttribute('href');
  if(href) {
    let domain = siteUrl.find(url => href.startsWith(url));
    let newHref = domain ?  href.replace(domain,'') : href;
    if (!newHref.startsWith(`/${siteLocale}`) && !newHref.startsWith('http') && !newHref.startsWith('mail') && !newHref.startsWith('#')) {
      siteLocaleLanguages.forEach((item) => {
        if (newHref.startsWith(`/${item}`)) {
          newHref = newHref.replace(`/${item}`,'');
        }  
      })
      child.setAttribute('href', `/${siteLocale}${newHref}`)
    }
  }
  });
  // console.log(el.body.innerHTML)
  let ht = el.body.innerHTML  
  return ht
}

export const isOdosWeek = false;

export const gcrReadingTypes = ['star', 'champion', 'superhero'];

export const donateModalReadsCount = 10;

export const allowedWebsiteRoles = ["language_champion", "translation_partner_admin", "publisher"];

export const containsURL = (value) => {
  const urlRegex = /\b(?:https?:\/\/|www\.|(?:bit\.ly|tinyurl\.com|rebrand\.ly|t2m\.io|bl\.ink|is\.gd|shorte\.st|go\.company\.link|cutt\.ly|ow\.ly|youtu\.be)\/[\w\-]+|[a-z0-9-]+\.(?:com|org|net|edu|gov|mil|int|info|biz|io|co|ai|me|xyz|cn|de|uk|br|ru|fr|au|in|ca|pl|nl|it|eu|tk)\b)/i;
  return urlRegex.test(value);
};


// WEBPACK FOOTER //
// ./src/lib/constants.js